<template>
  <div :class="isPriceInquiry ? '' : 'expressOrder'">
    <div v-if="isPriceInquiry">
      <!-- 这里是询价窗口 -->
      <price-inquiry :is-show="isPriceInquiry" @closePI="closePriceInquiry" />
    </div>
    <div v-if="!isPriceInquiry" class="orderInfo">
      <div id="box1" class="basicInformation">
        <div class="title center">
          <span style="font-size: 16px; font-weight: bold">{{
            $t('newOrder.BasicInformation')
          }}</span>
          <span>
            <el-button type="primary" @click="showPriceInquiry">{{
              $t('placeOrder.expressPriceInquiry')
            }}</el-button>
            <el-button @click="getCustomerPage(1)">{{ $t('placeOrder.copyOrder') }}</el-button>
          </span>
        </div>
        <div class="customerContent">
          <div class="selectContent">
            <el-form
              ref="baseRuleForm"
              :model="baseRuleForm"
              class="demo-baseRuleForm"
              inline
              label-position="top"
            >
              <el-row :gutter="50">
                <el-col :span="6">
                  <!--货物类型-->
                  <el-form-item
                    :label="$t('placeOrder.goodType')"
                    :rules="{
                      required: true,
                      message: $t('placeOrder.pleaseChoose'),
                      trigger: ['blur', 'change']
                    }"
                    prop="cargoType"
                    style="width: 100%"
                  >
                    <el-select
                      v-model="baseRuleForm.cargoType"
                      :placeholder="$t('placeOrder.pleaseChoose')"
                      clearable
                      style="width: 100%"
                      @change="cargoTypeChange"
                    >
                      <el-option :label="$t('placeOrder.Normal')" :value="0" />
                      <el-option :label="$t('GlobalSetObj.big01')" :value="1" />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <!-- 客户-->
                  <el-form-item
                    :label="$t('placeOrder.client')"
                    :rules="{
                      required: true,
                      message: $t('placeOrder.pleaseChoose'),
                      trigger: ['blur', 'change']
                    }"
                    prop="customerId"
                    style="width: 100%"
                  >
                    <el-select
                      v-model="baseRuleForm.customerId"
                      :placeholder="$t('placeOrder.pleaseChoose')"
                      clearable
                      filterable
                      style="width: 100%"
                      @change="selectCustomerId"
                    >
                      <el-option
                        v-for="item in customerList"
                        :key="item.id"
                        :label="item.username"
                        :value="item.id"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <!--商户-->
                  <el-form-item prop="merchantNumber" style="width: 100%">
                    <template slot="label">
                      <span>{{ $t('placeOrder.CommercialOwner') }}</span>
                      <el-tooltip class="QuestionMark" placement="top">
                        <div slot="content">{{ $t('placeOrder.collate') }}</div>
                        <svg-icon icon-class="QuestionMark" />
                      </el-tooltip>
                    </template>
                    <el-select
                      v-model="baseRuleForm.merchantNumber"
                      :disabled="isInput"
                      :filter-method="eventEnter"
                      :placeholder="$t('placeOrder.pleaseChoose')"
                      clearable
                      filterable
                      style="width: 100%"
                      @change="handlemerchantCode"
                      @focus="focuseventEnter"
                    >
                      <el-option
                        v-for="item in commercialList"
                        :key="item.id"
                        :label="item.merchantName"
                        :value="item.merchantNumber"
                      >
                        <span style="float: left">{{ item.merchantName || '--' }}</span>
                        <span style="margin-left: 20px; margin-right: 5px">{{
                          item.merchantNumber || '--'
                        }}</span>
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <!--快递类型-->
                  <el-form-item
                    :label="$t('GlobalSetObj.serviceTypes')"
                    prop="region"
                    style="width: 100%"
                  >
                    <el-select
                      v-model="baseRuleForm.expressType"
                      :placeholder="$t('placeOrder.pleaseChoose')"
                      clearable
                      style="width: 100%"
                    >
                      <!--   普快   -->
                      <el-option :label="$t('GlobalSetObj.localTrain')" :value="2" />
                      <!--   邮政   -->
                      <el-option :label="$t('GlobalSetObj.postal')" :value="3" />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <!--揽收类型-->
                  <el-form-item
                    :label="$t('newOrder.CollectionType')"
                    :rules="{
                      required: true,
                      message: $t('placeOrder.pleaseChoose'),
                      trigger: ['blur', 'change']
                    }"
                    prop="collectType"
                    style="width: 100%"
                  >
                    <el-select
                      v-model="baseRuleForm.collectType"
                      :placeholder="$t('placeOrder.pleaseChoose')"
                      clearable
                      style="width: 100%"
                    >
                      <el-option :label="$t('collectionCenter.dropOff')" value="1" />
                      <el-option :label="$t('collectionCenter.doorPickUp')" value="2" />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <!--客户订单-->
                  <el-form-item
                    :label="$t('newOrder.orderNumber')"
                    :rules="{
                      min: 2,
                      max: 50,
                      message: $t('GlobalSetObj.to50characters'),
                      trigger: 'blur'
                    }"
                    prop="customerNumber"
                    style="width: 100%"
                  >
                    <el-input
                      v-model.trim="baseRuleForm.customerNumber"
                      :disabled="isInput"
                      :placeholder="$t('placeOrder.pleaseInput')"
                      clearable
                      maxlength="50"
                      style="width: 100%"
                      type="text"
                      @blur="getCustomerNumber(baseRuleForm.customerNumber)"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <!--包裹类型-->
                  <el-form-item
                    :label="$t('placeOrder.packageType')"
                    :rules="{
                      required: true,
                      message: $t('placeOrder.pleaseChoose'),
                      trigger: ['blur', 'change']
                    }"
                    prop="orderPackageType"
                    style="width: 100%"
                  >
                    <el-select
                      v-model="baseRuleForm.orderPackageType"
                      :disabled="baseRuleForm.cargoType === 1 || baseRuleForm.cargoType === 0"
                      :placeholder="$t('placeOrder.pleaseChoose')"
                      clearable
                      style="width: 100%"
                    >
                      <el-option :label="$t('placeOrder.zhifa')" :value="1" />
                      <el-option :label="$t('orderCenterCont.hedan')" :value="2" />
                      <el-option :label="$t('placeOrder.Others')" :value="3" />
                      <el-option :label="$t('GlobalSetObj.big01')" :value="4" />
                      <el-option :label="$t('mdfeTranslate.multipleItemsPerOrderSingleNfe')" :value="5" />
                      <el-option :label="$t('mdfeTranslate.multipleItemsPerOrderMultiNfe')" :value="6" />
                      <!--<el-option label="合单" value="2" />-->
                    </el-select>
                  </el-form-item>
                </el-col>
                <!--                <el-col v-if="baseRuleForm.cargoType === 1" :span="6">-->
                <!--                  &lt;!&ndash;支付方式&ndash;&gt;-->
                <!--                  <el-form-item-->
                <!--                    :label="$t('placeOrder.PaymentMethod')"-->
                <!--                    :rules="{-->
                <!--                      required: true,-->
                <!--                      message: $t('placeOrder.pleaseChoose'),-->
                <!--                      trigger: ['blur', 'change']-->
                <!--                    }"-->
                <!--                    prop="paymentType"-->
                <!--                    style="width: 100%"-->
                <!--                  >-->
                <!--                    <el-select-->
                <!--                      v-model="baseRuleForm.paymentType"-->
                <!--                      :placeholder="$t('placeOrder.pleaseChoose')"-->
                <!--                      clearable-->
                <!--                      style="width: 100%"-->
                <!--                    >-->
                <!--                      <el-option :label="$t('placeOrder.SendersPayment')" :value="1" /> &lt;!&ndash;寄方支付&ndash;&gt;-->
                <!--                      <el-option :label="$t('placeOrder.ReceiversPayment')" :value="2" /> &lt;!&ndash;收方支付&ndash;&gt;-->
                <!--                    </el-select>-->
                <!--                  </el-form-item>-->
                <!--                </el-col>-->
              </el-row>
            </el-form>
          </div>
        </div>
      </div>
      <div id="box2" class="basicInformation">
        <div class="title center">
          <!--发件人-->
          <span style="font-size: 16px; font-weight: bold">{{ $t('placeOrder.senderName') }}</span>
          <el-button @click="customerAddress($t('placeOrder.senderName'))">{{ $t('placeOrder.senderAddress') }}
          </el-button>
        </div>
        <div class="customerContent">
          <div class="selectContent">
            <el-form
              ref="senderInfoForm"
              :model="senderInfoParams"
              class="demo-baseRuleForm"
              inline
              label-position="top"
            >
              <el-row :gutter="50">
                <el-col :span="8">
                  <!--姓名-->
                  <el-form-item
                    :label="$t('placeOrder.name')"
                    :rules="checkStr50"
                    prop="senderName"
                    style="width: 80%"
                  >
                    <el-input
                      v-model="senderInfoParams.senderName"
                      :placeholder="$t('placeOrder.pleaseInput')"
                      clearable
                      style="width: 80%"
                    />
                  </el-form-item>
                </el-col>
                <!--手机-->
                <el-col :span="8">
                  <el-form-item
                    :label="$t('GlobalSetObj.MobilePhone')"
                    :rules="isPhone"
                    prop="senderMobile"
                    style="width: 80%"
                  >
                    <el-input
                      v-model.trim="senderInfoParams.senderMobile"
                      :placeholder="$t('placeOrder.pleaseInput')"
                      clearable
                      style="width: 80%"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <!-- 税号 -->
                  <el-form-item
                    :label="$t('placeOrder.TaxCPF')"
                    :rules="isTax12"
                    prop="senderTax"
                    style="width: 80%"
                  >
                    <el-input
                      v-model.trim="senderInfoParams.senderTax"
                      :placeholder="$t('newOrder.PleaseEnter12Or14DigitTaxNumber')"
                      clearable
                      style="width: 80%"
                      @input="handleCNPJ(senderInfoParams.senderTax, 1)"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="50">
                <el-col :span="8">
                  <!--国家注册号-->
                  <el-form-item
                    :label="$t('GlobalSetObj.NationalRegistrationNumber')"
                    :rules="IeNumber"
                    prop="senderIeNumber"
                    style="width: 80%"
                  >
                    <el-input
                      v-model.trim="senderInfoParams.senderIeNumber"
                      :placeholder="$t('placeOrder.pleaseInput')"
                      clearable
                      style="width: 80%"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <!-- 邮编 -->
                  <el-form-item
                    :label="$t('placeOrder.zipcode')"
                    :rules="isZipCodeSender"
                    prop="senderZipcode"
                    style="width: 80%"
                  >
                    <el-input
                      v-model.trim="senderInfoParams.senderZipcode"
                      :maxlength="8"
                      :placeholder="$t('placeOrder.pleaseInput')"
                      clearable
                      style="width: 80%"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8" style="display: flex">
                  <!-- 发件人州 -->
                  <el-form-item
                    :label="$t('placeOrder.State')"
                    :rules="[
                      {
                        required: true,
                        message: $t('placeOrder.pleaseChoose'),
                        trigger: ['blur', 'change']
                      }
                    ]"
                    prop="senderState"
                    style="width: 30%"
                  >
                    <el-select
                      v-model="senderInfoParams.senderState"
                      :placeholder="$t('placeOrder.pleaseChoose')"
                      class="formTable"
                      filterable
                      style="width: 90%"
                      @change="stateChangeOption(1)"
                    >
                      <el-option
                        v-for="item in senderStateList"
                        :key="item.id"
                        :label="item.shortName"
                        :value="item.shortName"
                      />
                    </el-select>
                  </el-form-item>
                  <!-- 城市 -->
                  <el-form-item
                    :label="$t('placeOrder.city')"
                    :rules="cityComplement"
                    prop="senderCity"
                    style="width: 70%"
                  >
                    <el-select
                      v-model="senderInfoParams.senderCity"
                      :disabled="!senderInfoParams.senderState"
                      :placeholder="$t('placeOrder.pleaseChoose')"
                      :remote-method="getSenderCity"
                      class="formTable"
                      filterable
                      remote
                      reserve-keyword
                      style="width: 80%"
                      @visible-change="getSenderCity()"
                    >
                      <el-option
                        v-for="item in senderCityList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.name"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-show="isShowSenderMoreInfo" :gutter="50">
                <el-col :span="8">
                  <!-- 区 -->
                  <el-form-item
                    :label="$t('placeOrder.Area')"
                    :rules="only50Value"
                    prop="senderArea"
                    style="width: 80%"
                  >
                    <el-input
                      v-model="senderInfoParams.senderArea"
                      :placeholder="$t('placeOrder.pleaseInput')"
                      class="inputClass"
                      clearable
                      maxlength="50"
                      show-word-limit
                      style="width: 80%"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <!-- 街道 -->
                  <el-form-item
                    :label="$t('newOrder.Street')"
                    prop="senderStreet"
                    style="width: 80%"
                  >
                    <el-input
                      v-model="senderInfoParams.senderStreet"
                      :placeholder="$t('newOrder.ConfirmStreetNumber')"
                      class="inputClass"
                      clearable
                      maxlength="50"
                      show-word-limit
                      style="width: 80%"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <!--门牌号 -->
                  <el-form-item
                    :label="$t('placeOrder.HouseNumber')"
                    :rules="checkStr20"
                    prop="senderHouseNumber"
                    style="width: 80%"
                  >
                    <el-input
                      v-model.trim="senderInfoParams.senderHouseNumber"
                      :placeholder="$t('placeOrder.pleaseInput')"
                      class="inputClass"
                      clearable
                      maxlength="20"
                      show-word-limit
                      style="width: 80%"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <!-- 地址补充 -->
                  <el-form-item
                    :label="$t('placeOrder.addressComplement')"
                    :rules="only50Value"
                    prop="senderComplement"
                    style="width: 80%"
                  >
                    <el-input
                      v-model="senderInfoParams.senderComplement"
                      :placeholder="$t('placeOrder.pleaseInput')"
                      class="inputClass"
                      clearable
                      maxlength="50"
                      show-word-limit
                      style="width: 80%"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <!-- 邮箱 -->
                  <el-form-item
                    :label="$t('placeOrder.email')"
                    :rules="checkMail"
                    prop="senderMail"
                    style="width: 80%"
                  >
                    <el-input
                      v-model="senderInfoParams.senderMail"
                      :placeholder="$t('placeOrder.pleaseInput')"
                      clearable
                      style="width: 70%"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <!-- 电话 -->
                  <el-form-item
                    :label="$t('GlobalSetObj.userPhone')"
                    prop="senderPhone"
                    style="width: 80%"
                  >
                    <el-input
                      v-model="senderInfoParams.senderPhone"
                      :placeholder="$t('placeOrder.pleaseInput')"
                      clearable
                      style="width: 70%"
                    />
                    <span class="moreInfo" @click="showSenderMore">
                      《{{ $t('placeOrder.fold') }}</span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="!isShowSenderMoreInfo" :gutter="50">
                <el-col :span="24" style="margin-bottom: 10px">
                  <!--更多信息-->
                  <span class="moreInfo" @click="showSenderMore">{{ $t('placeOrder.moreInformation') }} 》</span>
                </el-col>
              </el-row>
              <el-row :gutter="20" class="verticallyCentered">
                <el-col :span="18">
                  <el-form-item
                    :label="$t('placeOrder.detailedAddress')"
                    :rules="[
                      {
                        required: true,
                        message: $t('placeOrder.pleaseInput'),
                        trigger: ['blur', 'change']
                      },
                      {
                        min: 2,
                        max: 200,
                        message: $t('newOrder.TdetailedAddressCharacter'),
                        trigger: 'blur'
                      }
                    ]"
                    prop="senderAddress"
                    style="width: 100%"
                  >
                    <el-input
                      v-model="senderInfoParams.senderAddress"
                      :placeholder="$t('newOrder.StreetHouseNumber')"
                      maxlength="200"
                      show-word-limit
                      type="text"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-button
                    :type="`${isInput === false ? 'primary' : 'info'}`"
                    @click="SynchronousCustomer($t('placeOrder.senderName'))"
                  >
                    {{ $t('placeOrder.SynchronizeClient') }}
                  </el-button>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>
      </div>
      <div id="box3" class="basicInformation">
        <div class="title center">
          <!-- 收件人 -->
          <span style="font-size: 16px; font-weight: bold">{{ $t('placeOrder.receiveName') }}</span>
          <!--客户收件地址 -->
          <el-button @click="customerAddress($t('placeOrder.receiveName'))">{{ $t('placeOrder.clientAddress') }}
          </el-button>
        </div>
        <div class="customerContent">
          <div class="selectContent">
            <el-form
              ref="receiverInfoForm"
              :model="receiverInfoParams"
              class="demo-baseRuleForm"
              inline
              label-position="top"
            >
              <el-row :gutter="50">
                <el-col :span="8">
                  <!--  姓名 -->
                  <el-form-item
                    :label="$t('placeOrder.name')"
                    :rules="checkStr50"
                    prop="receiveName"
                    style="width: 80%"
                  >
                    <el-input
                      v-model="receiverInfoParams.receiveName"
                      :placeholder="$t('placeOrder.pleaseInput')"
                      clearable
                      style="width: 80%"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <!-- 电话 -->
                  <el-form-item
                    :label="$t('GlobalSetObj.MobilePhone')"
                    :rules="isPhone"
                    prop="receiveMobile"
                    style="width: 80%"
                  >
                    <el-input
                      v-model="receiverInfoParams.receiveMobile"
                      :placeholder="$t('placeOrder.pleaseInput')"
                      clearable
                      style="width: 80%"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <!-- 税号 -->
                  <el-form-item
                    :label="$t('placeOrder.TaxCPF')"
                    :rules="isTax12"
                    prop="receiveTax"
                    style="width: 80%"
                  >
                    <el-input
                      v-model.trim="receiverInfoParams.receiveTax"
                      :placeholder="$t('newOrder.PleaseEnter12Or14DigitTaxNumber')"
                      clearable
                      style="width: 80%"
                      @input="handleCNPJ(receiverInfoParams.receiveTax, 2)"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="50">
                <el-col :span="8">
                  <!--国家注册号 -->
                  <el-form-item
                    :label="$t('GlobalSetObj.NationalRegistrationNumber')"
                    :rules="IeNumber1"
                    prop="receiveIeNumber"
                    style="width: 80%"
                  >
                    <el-input
                      v-model.trim="receiverInfoParams.receiveIeNumber"
                      :placeholder="$t('placeOrder.pleaseInput')"
                      clearable
                      style="width: 80%"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <!-- 邮编 -->
                  <el-form-item
                    :label="$t('placeOrder.zipcode')"
                    :rules="isZipCode"
                    prop="receiveZipcode"
                    style="width: 80%"
                  >
                    <el-input
                      v-model="receiverInfoParams.receiveZipcode"
                      :maxlength="8"
                      :placeholder="$t('placeOrder.pleaseInput')"
                      clearable
                      style="width: 80%"
                      @blur="zipcodeReceiveChange(receiverInfoParams.receiveZipcode)"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8" style="display: flex">
                  <!-- 州 -->
                  <el-form-item
                    :label="$t('placeOrder.State')"
                    :rules="[
                      {
                        required: true,
                        message: $t('placeOrder.pleaseChoose'),
                        trigger: ['blur', 'change']
                      }
                    ]"
                    prop="receiveState"
                    style="width: 30%"
                  >
                    <el-select
                      v-model="receiverInfoParams.receiveState"
                      :placeholder="$t('placeOrder.pleaseChoose')"
                      clearable
                      filterable
                      style="width: 90%"
                      @change="stateChangeOption(2)"
                    >
                      <el-option
                        v-for="item in senderStateList"
                        :key="item.id"
                        :label="item.shortName"
                        :value="item.shortName"
                      />
                    </el-select>
                  </el-form-item>
                  <!--城市 -->
                  <el-form-item
                    :label="$t('placeOrder.city')"
                    :rules="cityComplement"
                    prop="receiveCity"
                    style="width: 70%"
                  >
                    <el-select
                      v-model="receiverInfoParams.receiveCity"
                      :disabled="!receiverInfoParams.receiveState"
                      :placeholder="$t('placeOrder.pleaseChoose')"
                      :remote-method="getReceiveCity"
                      class="formTable"
                      filterable
                      remote
                      reserve-keyword
                      style="width: 80%"
                      @visible-change="getReceiveCity()"
                    >
                      <el-option
                        v-for="item in receiveCityList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.name"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-show="isShowRecipientMoreInfo" :gutter="50">
                <el-col :span="8">
                  <!--区 -->
                  <el-form-item
                    :label="$t('placeOrder.Area')"
                    :rules="only50Value"
                    prop="receiveArea"
                    style="width: 80%"
                  >
                    <el-input
                      v-model="receiverInfoParams.receiveArea"
                      :placeholder="$t('placeOrder.pleaseInput')"
                      class="inputClass"
                      clearable
                      maxlength="50"
                      show-word-limit
                      style="width: 80%"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <!--街道 -->
                  <el-form-item
                    :label="$t('newOrder.Street')"
                    prop="receiveStreet"
                    style="width: 80%"
                  >
                    <el-input
                      v-model="receiverInfoParams.receiveStreet"
                      :placeholder="$t('newOrder.ConfirmStreetNumber')"
                      class="inputClass"
                      clearable
                      maxlength="50"
                      show-word-limit
                      style="width: 80%"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <!--门牌号 -->
                  <el-form-item
                    :label="$t('placeOrder.HouseNumber')"
                    :rules="checkStr20"
                    prop="receiveHouseNumber"
                    style="width: 80%"
                  >
                    <el-input
                      v-model="receiverInfoParams.receiveHouseNumber"
                      :placeholder="$t('placeOrder.pleaseInput')"
                      class="inputClass"
                      clearable
                      maxlength="20"
                      show-word-limit
                      style="width: 80%"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <!-- 地址补充 -->
                  <el-form-item
                    :label="$t('placeOrder.addressComplement')"
                    :rules="only50Value"
                    prop="receiveComplement"
                    style="width: 80%"
                  >
                    <el-input
                      v-model="receiverInfoParams.receiveComplement"
                      :placeholder="$t('placeOrder.pleaseInput')"
                      class="inputClass"
                      clearable
                      maxlength="50"
                      show-word-limit
                      style="width: 80%"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <!-- 邮箱 -->
                  <el-form-item
                    :label="$t('placeOrder.email')"
                    :rules="checkMail"
                    prop="receiveMail"
                    style="width: 80%"
                  >
                    <el-input
                      v-model="receiverInfoParams.receiveMail"
                      :placeholder="$t('placeOrder.pleaseInput')"
                      clearable
                      style="width: 70%"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <!-- 电话 -->
                  <el-form-item
                    :label="$t('GlobalSetObj.userPhone')"
                    prop="receivePhone"
                    style="width: 80%"
                  >
                    <el-input
                      v-model="receiverInfoParams.receivePhone"
                      :placeholder="$t('placeOrder.pleaseInput')"
                      clearable
                      style="width: 70%"
                    />
                    <span class="moreInfo" @click="showRecipientMore">
                      《{{ $t('placeOrder.fold') }}</span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="!isShowRecipientMoreInfo" :gutter="50">
                <el-col :span="24" style="margin-bottom: 10px">
                  <!--更多信息-->
                  <span class="moreInfo" @click="showRecipientMore">{{ $t('placeOrder.moreInformation') }} 》</span>
                </el-col>
              </el-row>
              <el-row :gutter="20" class="verticallyCentered">
                <el-col :span="18">
                  <el-form-item
                    :label="$t('placeOrder.detailedAddress')"
                    :rules="[
                      {
                        required: true,
                        message: $t('placeOrder.pleaseInput'),
                        trigger: ['blur', 'change']
                      },
                      {
                        min: 2,
                        max: 200,
                        message: $t('newOrder.TdetailedAddressCharacter'),
                        trigger: 'blur'
                      }
                    ]"
                    prop="receiveAddress"
                    style="width: 100%"
                  >
                    <el-input
                      v-model="receiverInfoParams.receiveAddress"
                      :placeholder="$t('newOrder.StreetHouseNumber')"
                      clearable
                      maxlength="200"
                      show-word-limit
                      type="text"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <!-- 同步客户 -->
                  <el-button
                    :type="`${isInput === false ? 'primary' : 'info'}`"
                    @click="SynchronousCustomer($t('placeOrder.receiveName'))"
                  >
                    {{ $t('placeOrder.SynchronizeClient') }}
                  </el-button>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>
      </div>
      <!-- 发票信息 -->
      <div v-if="baseRuleForm.cargoType === 1" id="box5" class="basicInformation">
        <div class="title start">
          <span style="font-size: 16px; font-weight: bold">{{
            $t('newOrder.InvoiceInformation')
          }}</span>
        </div>
        <el-form
          ref="InvoiceInfoRuleForm" :model="InvoiceInfoForm" inline
          label-position="top"
        >
          <div class="customerContent" style="margin-top: 10px">
            <el-row>
              <el-col :span="5">
                <!-- 开票日期 -->
                <el-form-item
                  :label="$t('placeOrder.DateOfInvoicing')"
                  :rules="[
                    { required: true, message: $t('placeOrder.pleaseChoose'), trigger: 'change' }
                  ]"
                  prop="invoiceIssueDate"
                  style="display: block"
                >
                  <el-date-picker
                    v-model="InvoiceInfoForm.invoiceIssueDate"
                    :clearable="false"
                    :format="$i18n.locale === 'zh' ? zhDate : ptDate"
                    :picker-options="pickerOptions"
                    :placeholder="$t('newOrder.SelectDatetime')"
                    style="width: 100%"
                    type="date"
                    value-format="yyyy-MM-dd HH:mm:ss"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <!-- 开票金额 -->
                <el-form-item
                  :label="$t('placeOrder.InvoiceAmount')"
                  :rules="InvoiceAmountRule"
                  prop="invoiceMoney"
                  style="display: block"
                >
                  <el-input
                    v-model="InvoiceInfoForm.invoiceMoney"
                    :placeholder="$t('placeOrder.pleaseInput')"
                    clearable
                    style="width: 100%"
                    type="number"
                  />
                </el-form-item>
              </el-col>
              <!-- 发票号 -->
              <el-col :span="6">
                <el-form-item
                  :label="$t('placeOrder.InvoiceNumber')"
                  :rules="invoiceNumber"
                  prop="invoiceNumber"
                  style="display: block"
                >
                  <el-input
                    v-model.trim="InvoiceInfoForm.invoiceNumber"
                    :placeholder="$t('placeOrder.PleaseEnter6To16DigitInvoiceNumber')"
                    clearable
                    style="width: 100%"
                  />
                </el-form-item>
              </el-col>
              <!-- 发票序列号 -->
              <el-col :span="6">
                <el-form-item
                  :label="$t('GlobalSetObj.TheInvoiceSerialNumber')"
                  :rules="iceSerialIndex"
                  prop="invoiceSerialNumber"
                  style="display: block"
                >
                  <el-input
                    v-model.trim="InvoiceInfoForm.invoiceSerialNumber"
                    :placeholder="$t('placeOrder.PleaseEnter1To8invoiceSerialIndex')"
                    clearable
                    style="width: 100%"
                  />
                </el-form-item>
              </el-col>
              <!--发票密钥-->
              <el-col :span="12">
                <el-form-item
                  :label="$t('placeOrder.InvoiceKey')"
                  :rules="invoiceKey"
                  prop="invoiceAccessKey"
                  style="display: block"
                >
                  <el-input
                    v-model.trim="InvoiceInfoForm.invoiceAccessKey"
                    :placeholder="$t('placeOrder.PleaseEnter1To64DigitInvoiceNumber')"
                    clearable
                    rows="2"
                    style="width: 100%"
                    type="textarea"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form>
      </div>

      <div v-if="baseRuleForm.cargoType === 1" id="box4" class="basicInformation">
        <div class="title start">
          <span style="font-size: 16px; font-weight: bold">{{ $t('placeOrder.infoPackage') }}</span>
        </div>
        <el-form
          ref="packageRuleForm"
          :model="orderPackageListInfo"
          class="demo-baseRuleForm"
          inline
          label-position="top"
        >
          <div class="customerContent" style="margin-top: 10px">
            <div
              v-for="(item, index) in orderPackageListInfo.orderWaybillList"
              :key="index"
              class="selectContent"
            >
              <el-row v-if="index !== 0">
                <el-col
                  :span="24"
                  style="border-bottom: 1px dashed #cccccc; margin-bottom: 20px; margin-top: 20px"
                />
              </el-row>
              <div style="display: flex; justify-content: space-between; align-items: center">
                <span>{{ $t('collectionCenter.package') }}{{ index + 1 }}</span>
                <!--复制包裹-->
                <div>
                  <el-button size="small" type="primary" @click="copyPackage(index)">{{ $t('placeOrder.CopyPackage') }}
                  </el-button>
                  <!-- 删除包裹 -->
                  <el-button
                    v-if="orderPackageListInfo.orderWaybillList.length > 1"
                    size="small"
                    type="danger"
                    @click="delPackage(index)"
                  >{{ $t('placeOrder.Delete') }}
                  </el-button>
                </div>
              </div>
              <el-row
                v-for="(itemGood, goodIndex) in item.orderItemList"
                :key="goodIndex"
                :gutter="30"
                class="goodsBoxClass"
              >
                <el-col :span="5">
                  <!-- 产品SKU代码 -->
                  <el-form-item
                    :label="$t('collectionCenter.productSKUCode')"
                    :prop="'orderWaybillList.' + index + '.orderItemList.' + goodIndex + '.sku'"
                    :rules="[
                      { required: true, message: $t('placeOrder.pleaseChoose'), trigger: 'change' }
                    ]"
                    style="width: 100%"
                  >
                    <el-select
                      v-model="itemGood.sku"
                      :placeholder="$t('collectionCenter.pleaseChoose')"
                      clearable
                      filterable
                      style="width: 100%"
                      @change="getSkuAndName('sku', index, goodIndex, itemGood.sku)"
                      @focus="customeGetSkuAndName"
                    >
                      <el-option
                        v-for="(item, index) in skuAndNameOptions"
                        :key="index"
                        :label="item.skuCode"
                        :value="item.skuCode"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <!-- 产品名称 -->
                  <el-form-item
                    :label="$t('collectionCenter.productName')"
                    :prop="'orderWaybillList.' + index + '.orderItemList.' + goodIndex + '.name'"
                    :rules="[
                      { required: true, message: $t('placeOrder.pleaseChoose'), trigger: 'change' }
                    ]"
                    style="width: 100%"
                  >
                    <el-select
                      v-model="itemGood.name"
                      :placeholder="$t('collectionCenter.pleaseChoose')"
                      clearable
                      filterable
                      style="width: 100%"
                      @change="getSkuAndName('name', index, goodIndex, itemGood.name)"
                      @focus="customeGetSkuAndName"
                    >
                      <el-option
                        v-for="(item, index) in skuAndNameOptions"
                        :key="index"
                        :label="item.productName"
                        :value="item.productName"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <!-- 产品单价 -->
                  <el-form-item
                    :label="$t('collectionCenter.productUnitPrice')"
                    :prop="
                      'orderWaybillList.' + index + '.orderItemList.' + goodIndex + '.declaredValue'
                    "
                    :rules="checkFloatNumber1"
                    style="width: 100%"
                  >
                    <el-input
                      v-model="itemGood.declaredValue"
                      :placeholder="$t('placeOrder.pleaseInput')"
                      class="input-with-select"
                      clearable
                      type="number"
                      @blur="calculatePackageWeightAndVolume"
                    >
                      <span slot="prefix">R$</span>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <!-- 数量 -->
                  <el-form-item
                    :label="$t('placeOrder.quantity')"
                    :prop="
                      'orderWaybillList.' + index + '.orderItemList.' + goodIndex + '.quantity'
                    "
                    :rules="isNumber"
                    style="width: 100%"
                  >
                    <el-input
                      v-model="itemGood.quantity"
                      :placeholder="$t('placeOrder.pleaseInput')"
                      clearable
                      type="number"
                      @blur="calculatePackageWeightAndVolume"
                    />
                  </el-form-item>
                </el-col>

                <el-col :span="4">
                  <el-button
                    v-if="item.orderItemList.length > 1"
                    circle
                    class="el-icon-minus"
                    plain
                    size="mini"
                    type="danger"
                    @click="delGoods(index, goodIndex)"
                  />
                  <el-button
                    v-if="goodIndex === item.orderItemList.length - 1"
                    circle
                    class="el-icon-plus"
                    plain
                    size="mini"
                    type="success"
                    @click="addGoods(index)"
                  />
                </el-col>
              </el-row>
              <el-row justify="start" style="flex-wrap: wrap" type="flex">
                <el-col :span="8">
                  <!--扫描单号-->
                  <el-form-item
                    :label="$t('placeOrder.scanOrderNumber')"
                    :prop="'orderWaybillList.' + index + '.scanOrderNumber'"
                    :rules="[
                      {
                        validator: validateScanOrderNumber,
                        trigger: ['blur', 'change'],
                        index: index
                      }
                    ]"
                    style="display: block"
                  >
                    <el-input
                      v-model.trim="item.scanOrderNumber"
                      :placeholder="$t('placeOrder.pleaseInput')"
                      clearable
                      maxlength="80"
                      style="width: 100%"
                      @input="handleScanOrderNumberChange"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <!-- 包裹重量 -->
                  <el-form-item
                    :label="$t('placeOrder.parcelWeight')"
                    :prop="'orderWaybillList.' + index + '.weight'"
                    :rules="[
                      { required: true, message: $t('placeOrder.pleaseInput'), trigger: 'change' },
                      { validator: validateGreaterThan10, trigger: 'change' }
                    ]"
                    style="display: block"
                  >
                    <el-input
                      v-model="item.weight"
                      :disabled="true"
                      :placeholder="$t('placeOrder.pleaseInput')"
                      clearable
                      style="width: 100%"
                      type="number"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <!-- 包裹体积 -->
                  <el-form-item
                    :label="$t('GlobalSetObj.packageVolume') + '(m³)'"
                    :prop="'orderWaybillList.' + index + '.volume'"
                    :rules="[
                      { required: true, message: $t('placeOrder.pleaseInput'), trigger: 'change' },
                      { validator: validateGreaterThan10, trigger: 'change' }
                    ]"
                    style="display: block"
                  >
                    <el-input
                      v-model="item.volume"
                      :disabled="true"
                      :placeholder="$t('placeOrder.pleaseInput')"
                      clearable
                      style="width: 100%"
                      type="number"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <div class="addPackageClass">
              <span class="el-icon-plus" @click="addPackage">
                {{ $t('placeOrder.addPackage') }}
              </span>
            </div>
          </div>
        </el-form>
      </div>

      <div v-else id="box4" class="basicInformation">
        <div class="title center">
          <span style="font-size: 16px; font-weight: bold">{{ $t('placeOrder.infoPackage') }}</span>
          <el-button v-show="baseRuleForm.cargoType === 0" icon="el-icon-plus" @click="addPackage">
            {{ $t('placeOrder.addPackage') }}
          </el-button>
        </div>
        <el-form
          ref="packageRuleForm"
          :model="orderPackageListInfo"
          class="demo-baseRuleForm"
          inline
          label-position="top"
        >
          <div
            v-for="(item, index) in orderPackageListInfo.orderWaybillList"
            :key="index"
            class="customerContent"
            style="margin-top: 10px"
          >
            <div class="selectContent">
              <el-row :gutter="30">
                <el-col :span="4">
                  <!-- 包裹类型 -->
                  <el-form-item
                    :label="$t('placeOrder.packageType')"
                    :prop="'orderWaybillList.' + index + '.waybillType'"
                    :rules="[
                      { required: true, message: $t('placeOrder.pleaseChoose'), trigger: 'change' }
                    ]"
                  >
                    <el-select
                      v-model="item.waybillType"
                      :placeholder="$t('placeOrder.pleaseChoose')"
                      clearable
                    >
                      <el-option
                        v-for="packageType in item.packageType"
                        :key="packageType.code"
                        :label="packageType.code"
                        :value="packageType.value"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <!--正常件-->
                <template v-if="baseRuleForm.cargoType === 0">
                  <el-col :span="12">
                    <el-row :gutter="10">
                      <!-- 长度 -->
                      <el-col :span="8">
                        <el-form-item
                          :label="$t('placeOrder.long')"
                          :prop="'orderWaybillList.' + index + '.length'"
                          :rules="checkFloatNumber"
                        >
                          <el-input
                            v-model="item.length"
                            :placeholder="$t('placeOrder.pleaseInput')"
                            clearable
                            type="number"
                            @change="computational"
                          />
                        </el-form-item>
                      </el-col>
                      <!-- 宽度 -->
                      <el-col :span="8">
                        <el-form-item
                          :label="$t('placeOrder.width')"
                          :prop="'orderWaybillList.' + index + '.width'"
                          :rules="checkFloatNumber"
                        >
                          <el-input
                            v-model="item.width"
                            :placeholder="$t('placeOrder.pleaseInput')"
                            clearable
                            type="number"
                            @change="computational"
                          />
                        </el-form-item>
                      </el-col>
                      <!-- 高度 -->
                      <el-col :span="8">
                        <el-form-item
                          :label="$t('placeOrder.height')"
                          :prop="'orderWaybillList.' + index + '.height'"
                          :rules="checkFloatNumber"
                        >
                          <el-input
                            v-model="item.height"
                            :placeholder="$t('placeOrder.pleaseInput')"
                            clearable
                            type="number"
                            @change="computational"
                          />
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col :span="5" class="verticallyCentered">
                    <!-- 包裹重量 -->
                    <el-form-item
                      :label="$t('placeOrder.parcelWeight')"
                      :prop="'orderWaybillList.' + index + '.weight'"
                      :rules="checkFloatNumber"
                    >
                      <el-input
                        v-model="item.weight"
                        :placeholder="$t('placeOrder.pleaseInput')"
                        clearable
                        type="number"
                        @change="computational"
                      />
                    </el-form-item>
                  </el-col>
                </template>
                <!--大件-->
                <template v-else>
                  <el-col :span="14">
                    <el-row :gutter="10">
                      <!-- 总件数 -->
                      <el-col :span="8">
                        <el-form-item
                          :key="totalFormKey"
                          :label="$t('operationCenter.TotalNumberOfPieces')"
                          :rules="totalNumberPieces"
                          prop="totalParcel"
                        >
                          <el-input-number
                            :key="totalKey"
                            v-model="orderPackageListInfo.totalParcel"
                            :disabled="
                              orderPackageListInfo.detailList &&
                                orderPackageListInfo.detailList.length > 0
                            "
                            :max="999"
                            :min="1"
                            :placeholder="$t('placeOrder.pleaseInput')"
                            :precision="0"
                            :step="1"
                            style="width: 100%"
                          />
                        </el-form-item>
                      </el-col>
                      <!-- 包裹总重量 -->
                      <el-col :span="8">
                        <el-form-item
                          :key="totalFormKey"
                          :label="$t('GlobalSetObj.pesoTotal')"
                          :rules="pesoTotal"
                          prop="totalParcelDeclaredWeight"
                        >
                          <el-input-number
                            :key="totalKey"
                            v-model="orderPackageListInfo.totalParcelDeclaredWeight"
                            :disabled="
                              orderPackageListInfo.detailList &&
                                orderPackageListInfo.detailList.length > 0
                            "
                            :max="9999"
                            :min="0.001"
                            :placeholder="$t('placeOrder.pleaseInput')"
                            :precision="3"
                            :step="1"
                            clearable
                            style="width: 100%"
                          />
                        </el-form-item>
                      </el-col>
                      <!-- 包裹总体积 -->
                      <el-col :span="8">
                        <el-form-item
                          :key="totalFormKey"
                          :label="$t('GlobalSetObj.PackageTotalWeight') + '(m³)'"
                          :rules="parcelVolume"
                          prop="totalParcelDeclaredVolume"
                        >
                          <el-input-number
                            :key="totalKey"
                            v-model="orderPackageListInfo.totalParcelDeclaredVolume"
                            :disabled="
                              orderPackageListInfo.detailList &&
                                orderPackageListInfo.detailList.length > 0
                            "
                            :max="999"
                            :min="0.001"
                            :placeholder="$t('placeOrder.pleaseInput')"
                            :precision="3"
                            :step="1"
                            clearable
                            style="width: 100%"
                          />
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col :span="5">
                    <!--补充详细重量体积-->
                    <span class="volumeClass" @click="openDetailWindow()">{{
                      $t('GlobalSetObj.AddDetailedWeightAndVolume')
                    }}</span>
                    <!--<el-button type="text" @click="openDetailWindow()">{{ $t('GlobalSetObj.AddDetailedWeightAndVolume') }}</el-button>-->
                  </el-col>
                </template>
                <el-col
                  v-if="orderPackageListInfo.orderWaybillList.length > 1"
                  :span="1"
                  class="delPackge"
                >
                  <!-- 删除包裹 -->
                  <el-button type="danger" @click="delPackage(index)">{{ $t('placeOrder.Delete') }}
                  </el-button>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="5">
                  <!-- 开票日期 -->
                  <el-form-item
                    :label="$t('placeOrder.DateOfInvoicing')"
                    :prop="'orderWaybillList.' + index + '.invoiceIssueDate'"
                    :rules="[
                      { required: true, message: $t('placeOrder.pleaseChoose'), trigger: 'change' }
                    ]"
                    style="display: block"
                  >
                    <el-date-picker
                      v-model="item.invoiceIssueDate"
                      :clearable="false"
                      :format="$i18n.locale === 'zh' ? zhDate : ptDate"
                      :picker-options="pickerOptions"
                      :placeholder="$t('newOrder.SelectDatetime')"
                      style="width: 100%"
                      type="date"
                      value-format="yyyy-MM-dd HH:mm:ss"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <!-- 开票金额 -->
                  <el-form-item
                    :label="$t('placeOrder.InvoiceAmount')"
                    :prop="'orderWaybillList.' + index + '.invoiceMoney'"
                    :rules="InvoiceAmountRule"
                    style="width: 100%"
                  >
                    <el-input
                      v-model="item.invoiceMoney"
                      :placeholder="$t('placeOrder.pleaseInput')"
                      clearable
                      type="number"
                    />
                  </el-form-item>
                </el-col>
                <!-- 发票号 -->
                <el-col :span="6">
                  <el-form-item
                    :label="$t('placeOrder.InvoiceNumber')"
                    :prop="'orderWaybillList.' + index + '.invoiceNumber'"
                    :rules="invoiceNumber"
                    style="display: block"
                  >
                    <el-input
                      v-model.trim="item.invoiceNumber"
                      :placeholder="$t('placeOrder.PleaseEnter6To16DigitInvoiceNumber')"
                      clearable
                      style="width: 100%"
                    />
                  </el-form-item>
                </el-col>
                <!-- 发票序列号 -->
                <el-col :span="6">
                  <el-form-item
                    :label="$t('GlobalSetObj.TheInvoiceSerialNumber')"
                    :prop="'orderWaybillList.' + index + '.invoiceSerialNumber'"
                    :rules="iceSerialIndex"
                    style="display: block"
                  >
                    <el-input
                      v-model.trim="item.invoiceSerialNumber"
                      :placeholder="$t('placeOrder.PleaseEnter1To8invoiceSerialIndex')"
                      clearable
                      style="width: 100%"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <!--扫描单号-->
                  <el-form-item
                    :label="$t('placeOrder.scanOrderNumber')"
                    :prop="'orderWaybillList.' + index + '.scanOrderNumber'"
                    style="display: block"
                  >
                    <el-input
                      v-model.trim="item.scanOrderNumber"
                      :placeholder="$t('placeOrder.pleaseInput')"
                      clearable
                      maxlength="80"
                    />
                  </el-form-item>
                </el-col>
                <!--发票密钥-->
                <el-col :span="12">
                  <el-form-item
                    :label="$t('placeOrder.InvoiceKey')"
                    :prop="'orderWaybillList.' + index + '.invoiceAccessKey'"
                    :rules="invoiceKey"
                    style="display: block"
                  >
                    <el-input
                      v-model.trim="item.invoiceAccessKey"
                      :placeholder="$t('placeOrder.pleaseInput')"
                      clearable
                      rows="2"
                      style="width: 100%"
                      type="textarea"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24" style="border-bottom: 1px dashed #cccccc; margin-bottom: 10px" />
              </el-row>
              <el-row
                v-for="(itemGood, goodIndex) in item.orderItemList"
                :key="goodIndex"
                :gutter="30"
              >
                <el-col :span="7">
                  <!-- 物品名称 -->
                  <el-form-item
                    :label="$t('placeOrder.wpName')"
                    :prop="'orderWaybillList.' + index + '.orderItemList.' + goodIndex + '.name'"
                    :rules="[
                      { required: true, message: $t('placeOrder.pleaseInput'), trigger: 'change' }
                    ]"
                    style="width: 100%"
                  >
                    <el-input
                      v-model="itemGood.name"
                      :placeholder="$t('placeOrder.pleaseInput')"
                      clearable
                      maxlength="128"
                      show-word-limit
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="7">
                  <!-- 物品单价 -->
                  <el-form-item
                    :label="$t('placeOrder.declaredValue')"
                    :prop="
                      'orderWaybillList.' + index + '.orderItemList.' + goodIndex + '.declaredValue'
                    "
                    :rules="checkFloatNumber1"
                    style="width: 100%"
                  >
                    <el-input
                      v-model="itemGood.declaredValue"
                      :placeholder="$t('placeOrder.pleaseInput')"
                      class="input-with-select"
                      clearable
                      type="number"
                    >
                      <span slot="prefix">R$</span>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="7">
                  <!-- 数量 -->
                  <el-form-item
                    :label="$t('placeOrder.quantity')"
                    :prop="
                      'orderWaybillList.' + index + '.orderItemList.' + goodIndex + '.quantity'
                    "
                    :rules="isNumber"
                    style="width: 100%"
                  >
                    <el-input
                      v-model="itemGood.quantity"
                      :placeholder="$t('placeOrder.pleaseInput')"
                      clearable
                      type="number"
                    />
                  </el-form-item>
                </el-col>
                <el-col v-if="item.orderItemList.length > 1" :span="1" class="delPackge">
                  <div>
                    <el-button type="danger" @click="delGoods(index, goodIndex)">{{ $t('placeOrder.Delete') }}
                    </el-button>
                  </div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24" class="verticallyCentered">
                  <div
                    style="
                      cursor: pointer;
                      color: #409eff;
                      font-size: 16px;
                      font-weight: bold;
                      margin-bottom: 10px;
                    "
                    @click="addGoods(index)"
                  >
                    <i class="el-icon-plus" style="font-size: 16px; font-weight: bold" />
                    <span style="margin-left: 5px">{{ $t('orderCenterCont.AddProducts') }}</span>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <div class="forecastClass">
        <div>
          <div class="forecast_div">
            R$<span class="forecast_span">{{ forecastNumber || '--' }}</span>
          </div>
          <!-- 预估运费（仅供参考，请以实际应付金额为准）-->
          <span style="color: #656865">{{ $t('placeOrder.estimatedShippingTips') }}</span>
        </div>
        <div>
          <!--    清空      -->
          <el-button @click="empty">{{ $t('newOrder.empty') }}</el-button>
          <!--    下单      -->
          <el-button type="primary" @click="placeAnOrder">{{ $t('placeOrder.test') }}</el-button>
        </div>
      </div>
    </div>
    <div v-if="!isPriceInquiry" class="orderInfoList">
      <div v-for="(item, index) in orderInfoList" :key="item.id">
        <el-link
          :type="`${ulLi === index + 1 ? 'primary' : ''}`"
          :underline="false"
          @click="scrollTop(item.id)"
        >{{ item.title }}
        </el-link>
      </div>
    </div>
    <!--  下单成功倒计时  -->
    <el-dialog
      :append-to-body="true"
      :close-on-click-modal="false"
      :show-close="false"
      :title="$t('GlobalSetObj.tips')"
      :visible.sync="countdownDialog"
      :width="$i18n.locale == 'zh' ? '450px' : '550px'"
      top="30vh"
    >
      <div
        style="display: flex; align-items: center; justify-content: center; margin: 20px 0 30px 0"
      >
        <div class="sucessIcon">
          <i class="iconfont icon-chenggong1" />
        </div>
        <div style="font-weight: bold; font-size: 20px">
          {{ $t('orderCenterCont.orderWasPlacedSuccessfully') }}
        </div>
      </div>
      <div slot="footer" style="text-align: center">
        <el-button size="small" style="margin-right: 10px" @click="toWillyNumber">{{ $t('GlobalSetObj.toWillyNumber') }}
        </el-button>
        <el-button size="small" type="primary" @click="continuePlaceOrders">{{ $t('placeOrder.continueOrders') }}
        </el-button>
      </div>
    </el-dialog>

    <!--  复制订单  -->
    <el-dialog
      :append-to-body="true"
      :close-on-click-modal="false"
      :show-close="true"
      :visible.sync="orderDialog"
      custom-class="copyOrder"
      top="20vh"
      width="900px"
    >
      <div>
        <div style="color: #303133; font-size: 20px; font-weight: bold">
          {{ $t('placeOrder.PleaseInputNumber') }}
        </div>
        <div style="font-size: 18px; margin-top: 15px; margin-bottom: 15px">
          <el-form
            ref="ruleForm" :model="order" class="demo-ruleForm"
            @submit.native.prevent
          >
            <el-form-item
              :rules="{
                required: true,
                message: $t('placeOrder.pleaseInput'),
                trigger: ['blur', 'change']
              }"
              prop="WaybillNumber"
              style="width: 60%"
            >
              <el-input
                v-model="order.WaybillNumber"
                :placeholder="$t('GlobalSetObj.pedidoCliente')"
                clearable
                @keyup.enter.native.prevent="getSearch"
              >
                <el-button
                  slot="append" icon="el-icon-search" type="primary"
                  @click="getSearch"
                />
              </el-input>
            </el-form-item>
          </el-form>
        </div>

        <!--  表格数据  -->
        <el-table
          :data="tableData"
          :header-cell-style="{ background: '#d9d9d9' }"
          border
          style="width: 100%"
          @row-click="confirmOrderDialog"
        >
          <el-table-column :label="$t('GlobalSetObj.client')" prop="customerName" width="180" />
          <el-table-column
            :label="$t('placeOrder.destinationZone')"
            prop="receiveAddress"
            width="220"
          >
            <template slot-scope="scope">
              <div>
                {{ $t('placeOrder.State') }}: {{ scope.row.receiverInfo.receiveState || '- -' }}
              </div>
              <div>{{ $t('newOrder.City') }} {{ scope.row.receiverInfo.receiveCity || '- -' }}</div>
              <div>
                {{ $t('orderDetails.Area') }}: {{ scope.row.receiverInfo.receiveArea || '- -' }}
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('placeOrder.destinationAddress')" prop="receiveAddress">
            <template slot-scope="scope">
              <div>{{ scope.row.receiverInfo.receiveAddress || '- -' }}</div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="orderDialog = false">{{ $t('GlobalSetObj.Cancelar') }}</el-button>
        <el-button type="primary" @click="confirmOrderDialog(0)">{{ $t('GlobalSetObj.confirm') }}
        </el-button>
      </div>
    </el-dialog>
    <!--  发件地址  -->
    <el-dialog
      :append-to-body="true"
      :close-on-click-modal="false"
      :show-close="true"
      :title="`${addressTitle}${$t('customerManagements.address')}`"
      :visible.sync="addressDialog"
      top="10vh"
      width="800px"
    >
      <div>
        <div style="font-size: 18px; margin-bottom: 15px">
          {{ $t('GlobalSetObj.pleaseChoose') }}{{ addressTitle
          }}{{ $t('customerManagements.address') }}
        </div>
        <div class="addressList">
          <el-select
            v-model="addressForm.type"
            :placeholder="$t('GlobalSetObj.pleaseChoose')"
            style="width: 150px"
          >
            <el-option
              v-if="addressTitle === `${$t('placeOrder.senderName')}`"
              :label="addressTitle"
              :value="addressTitle"
            />
            <el-option v-else :label="addressTitle" :value="addressTitle" />
            <el-option :label="$t('GlobalSetObj.zipCode')" value="2" />
          </el-select>
        </div>
        <div style="width: 60%; margin-top: 15px">
          <el-input
            v-model="addressForm.name"
            :placeholder="$t('GlobalSetObj.pleaseInput')"
            clearable
            @keyup.enter.native="getSearchAddress"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              style="background-color: #409eff; color: black"
              @click="getSearchAddress"
            />
          </el-input>
        </div>
        <div class="addressClass">
          <div v-if="customerAddressList.length > 0">
            <div
              v-for="item in customerAddressList"
              :key="item.id"
              class="addressItem"
              @click="selectAddress(item, addressTitle)"
            >
              <div>
                <span style="color: #000000">{{ item.name || '--' }}</span>
                <span style="margin-left: 20px">{{ item.phone || '--' }}</span>
                <span style="margin-left: 20px">{{ item.cpf || '--' }}</span>
              </div>
              <div>
                <span style="">{{ item.zipcode || '--' }}</span>
                <span style="margin-left: 20px">{{ item.state || '--' }}</span>
                <span style="margin-left: 20px">{{ item.city || '--' }}</span>
              </div>
              <div>
                <span style="">{{ item.area || '--' }}</span>
                <span style="margin-left: 20px">{{ item.addressDetail || '--' }}</span>
              </div>
            </div>
          </div>
          <div v-else class="nodataImage">
            <svg-icon icon-class="noData" />
          </div>
        </div>
        <!--  分页  -->
        <el-pagination
          :current-page="queryForm.pageNumber"
          :page-size="queryForm.pageSize"
          :page-sizes="[5, 10, 20]"
          :total="queryForm.total"
          background
          layout="total, sizes, prev, pager, next, jumper"
          style="margin: 10px 0; float: right"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
      <div slot="footer" class="dialog-footer" />
    </el-dialog>
    <!--补充详细重量体积 多件包裹重量体积-->
    <el-dialog
      :append-to-body="true"
      :close-on-click-modal="false"
      :show-close="true"
      :title="$t('GlobalSetObj.WeightVolumeMultiplePackages')"
      :visible.sync="isOpenDetailWindow"
      custom-class="weightVolume"
      top="10vh"
      width="800px"
    >
      <div>
        <volume-weight
          :key="isOpenDetailWindow"
          ref="openDetail"
          :click-detail="clickDetail"
          @save="getSaveDetail"
        />
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isOpenDetailWindow = false">{{ $t('GlobalSetObj.Cancelar') }}</el-button>
        <el-button type="primary" @click="saveDetail">{{ $t('GlobalSetObj.Salve') }}</el-button>
      </div>
    </el-dialog>
    <!--复制包裹-->
    <el-dialog
      :append-to-body="true"
      :close-on-click-modal="false"
      :show-close="true"
      :title="$t('placeOrder.CopyPackageInformation')"
      :visible.sync="showCopyPackageWindow"
      custom-class="weightVolume"
      top="6vh"
      width="800px"
      @close="closeCopyPackageWindow"
    >
      <div style="padding: 20px">
        <div style="display: flex">
          <!--包裹总件数-->
          <div style="flex: 1">
            {{ $t('GlobalSetObj.TotalNumberOfPackages') }}：{{ copyForm.totalPackageNum }}
          </div>
          <!--包裹总重量-->
          <div style="flex: 1">
            {{ $t('GlobalSetObj.pesoTotal1') }}：{{ copyForm.totalPackageWeight }} KG
          </div>
          <!--包裹总体积-->
          <div style="flex: 1">
            {{ $t('GlobalSetObj.PackageTotalWeight') }}：{{ copyForm.totalPackageVolume }} m³
          </div>
        </div>
        <el-divider />
        <div>
          <el-form ref="copyFormRef" :model="copyForm" label-position="top">
            <!--复制包裹数量-->
            <el-form-item
              :label="$t('placeOrder.CopyPackageQuantity')"
              :rules="[
                {
                  required: true,
                  message: $t('GlobalSetObj.pleaseInput'),
                  trigger: ['blur', 'change']
                },
                { validator: copyNumber, trigger: ['blur'] }
              ]"
              prop="copyPackageNum"
            >
              <el-input
                v-model="copyForm.copyPackageNum"
                :placeholder="$t('GlobalSetObj.pleaseInput')"
              />
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="showCopyPackageWindow = false">{{ $t('GlobalSetObj.Cancelar') }}
        </el-button>
        <el-button size="small" type="primary" @click="confirmCopy">{{ $t('GlobalSetObj.confirm') }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  addCustomerAddress,
  checkCustomerNumber,
  checkedzipcode,
  CopyOrder,
  createOrder,
  customerMerchant,
  getAddressByZipCode,
  inquireMerchant,
  pageCustomerAddress,
  queryCalculateFee,
  selectCity,
  selectState,
  skuInfoOptionSelect,
  getBillableWeight
} from '@/api/orderApi';
import {
  checkAddressComplement,
  checkCityComplement,
  checkCNPJ,
  checkFloatNumber,
  E_Mail,
  IENumber,
  InvoiceAmounts,
  invoiceNumberCheck,
  invoiceSeriakey,
  invoiceSerialIndex,
  isNumber,
  isZipCodexiaodan,
  MobilePhoneNumber,
  priceOfGoods
} from '@/utils/validate';
import { CustomerPage } from '@/api/customer';
import { cloneDeep } from 'lodash-es';
import { Loading } from 'element-ui';
import { sensitiveViewPlaintext } from '@/api/user';
import { orderCNPJ } from '@/utils/strUtil';

const debounceHandle = (function() {
  let timer;
  return function(callback, ms) {
    clearTimeout(timer);
    timer = setTimeout(callback, ms);
  };
})();
export default {
  name: 'Order',
  components: {
    // 补充详细重量体积
    'volume-weight': () => import('./volumeWeight'),
    'price-inquiry': () => import('./priceInquiry/index')
  },
  data() {
    // 数量验证
    const quantityVerification = (rule, value, callback) => {
      // rule.int 1: 正整数 2：整数或浮点数（正数）
      // rule.length: 小数点位数
      let regex = null;
      if (rule.length > 0) {
        const reg = '^[0-9]+(.?[0-9]{1,' + rule.length + '})?$';
        regex = new RegExp(reg);
      }
      if (rule.required) {
        if (value) {
          if (rule.int === 1) {
            if (!Number.isInteger(Number(value))) {
              callback(new Error(this.$t('collectionCenter.pleaseInputInteger')));
            }
          }
          if (value < rule.min) {
            callback(new Error(this.$t('placeOrder.数字不能小于') + rule.min));
          }
          if (value > rule.max) {
            callback(new Error(this.$t('placeOrder.数字不能大于') + rule.max));
          }
          if (regex && !regex.test(value)) {
            callback(new Error(this.$t('placeOrder.最多保留3位小数')));
          }
          callback();
        } else {
          callback(new Error(this.$t('placeOrder.pleaseInput')));
        }
      } else {
        if (value) {
          if (rule.int === 1) {
            if (!Number.isInteger(Number(value))) {
              callback(new Error(this.$t('collectionCenter.pleaseInputInteger')));
            }
          }
          if (value < rule.min) {
            callback(new Error(this.$t('placeOrder.数字不能小于') + rule.min));
          }
          if (value > rule.max) {
            callback(new Error(this.$t('placeOrder.数字不能大于') + rule.max));
          }
          if (regex && !regex.test(value)) {
            callback(new Error(this.$t('placeOrder.最多保留3位小数')));
          }
          callback();
        } else {
          callback();
        }
      }
    };
    const validateGreaterThan10 = (rule, value, callback) => {
      if (value <= 0) {
        callback(new Error(this.$t('collectionCenter.valueMustExceedTen')));
      } else {
        callback();
      }
    };
    const copyNumber = (rule, value, callback) => {
      const regex = /^[1-9]\d*$/;
      const notNum = 99 - this.orderPackageListInfo.orderWaybillList.length;
      if (regex.test(value)) {
        if (value > notNum) {
          callback(new Error(this.$t('placeOrder.packagesTotalNumberCannotExceed99'))); // 包裹总数不能超过99
        } else {
          this.changeCopyPackageNum(value);
          callback();
        }
      } else {
        callback(new Error(this.$t('placeOrder.enterIntegers'))); // 请输入正整数
      }
    };
    const isZipCodexiaodanSender = (rule, value, callback) => {
      const reg = /^[0-9]{8}$/;
      if (reg.test(value)) {
        const data = {};
        data.zipcode = value;
        const loading = Loading.service({
          fullscreen: true,
          lock: true,
          spinner: 'el-icon-loading',
          text: 'loading...',
          background: 'rgba(250, 250, 250, 0.6)'
        });
        checkedzipcode(data)
          .then((res) => {
            loading.close();
            this.zipcodeSendChange(value);
            if (res.code === 200) {
              const zipState = res.data?.stateTwoCode || '';
              this.stateTwoCode = zipState;
              const customerState = this.customerObj?.state || '';
              console.log(
                this.stateTwoCode,
                customerState,
                'customerState',
                this.baseRuleForm.cargoType
              );
              // 当货物类型 = 1 时才校验
              if (this.baseRuleForm.cargoType === 1) {
                if (!zipState) {
                  return callback(new Error(this.$t('placeOrder.zipCodeTip01')));
                }
                // 只有：两个都不是 SP → 才报错
                if (zipState !== 'SP' && customerState !== zipState) {
                  return callback(new Error(this.$t('placeOrder.zipCodeTip01')));
                }
              }
              // 只要有一个是 SP，就正常通过
              return callback();
            }
          })
          .catch((err) => {
            loading.close();
            return callback(new Error(err.msg));
          });
      } else {
        return callback(new Error(this.$t('placeOrder.input8ZipCode')));
      }
    };
    return {
      billableWeight: 0,
      isPriceInquiry: false, // 询价窗口
      validateGreaterThan10,
      totalParcelDeclaredWeight: 0,
      totalParcelDeclaredVolume: 0,
      skuAndNameOptions: [], // 用于存储’SKU‘和’产品名称‘选项
      InvoiceInfoForm: {
        invoiceIssueDate: '',
        invoiceMoney: '',
        invoiceNumber: '',
        invoiceSerialNumber: '',
        invoiceAccessKey: ''
      },
      // 预估运费
      forecastNumber: '',
      // 是否可以输入
      isInput: true,
      // 是否同步,
      isSync: true,
      // 倒计时弹窗
      countdownDialog: false,
      // 复制订单
      orderDialog: false,
      order: {
        WaybillNumber: null // 搜索物流订单
      },
      tableHeaderList: [
        { id: 1, label: this.$t('GlobalSetObj.client'), prop: 'customerName', cloWidth: '180' },
        {
          id: 2,
          label: this.$t('placeOrder.destinationZone'),
          prop: 'receiveAddress',
          cloWidth: '200'
        },
        { id: 3, label: this.$t('placeOrder.destinationAddress'), prop: 'receiveAddress' }
      ],
      tableData: [],
      orderInformation: {}, // 复用订单
      addressDialog: false, // 客户地址
      addressTitle: this.$t('placeOrder.senderName'),
      addressForm: {
        type: this.$t('placeOrder.senderName'),
        name: ''
      },
      customerAddressList: [],
      queryForm: {
        pageSize: 10,
        pageNumber: 1,
        total: 0
      },
      orderInfoList: [
        {
          id: 1,
          title: this.$t('placeOrder.baseData')
        },
        {
          id: 2,
          title: this.$t('placeOrder.senderName')
        },
        {
          id: 3,
          title: this.$t('placeOrder.receiveName')
        },
        {
          id: 4,
          title: this.$t('placeOrder.infoPackage')
        }
      ],
      baseRuleForm: {
        collectType: '', // 揽收类型
        expressType: 2, // 服务类型
        customerNumber: '', // 客户订单
        customerId: '', // 客户id
        merchantNumber: '', // 商户COde
        merchantName: '', // 商户名
        orderPackageType: 1, // 包裹类型
        cargoType: 0, // 货物类型
        paymentType: null // 支付方式 1：寄方支付 2：收方支付
      },
      // 更多信息展示
      isShowSenderMoreInfo: false,
      isShowRecipientMoreInfo: false,
      orderPackageListInfo: {
        totalParcelDeclaredWeight: undefined, //  包裹总重量（kg）
        totalParcelDeclaredVolume: undefined, //  包裹总体积（m³）
        totalParcel: 1, // 包裹总数量
        detailList: [],
        orderWaybillList: [
          {
            dictName: 'WRPER1',
            length: 0, // 长
            width: 0, // 宽
            height: 0, // 高
            weight: 0, // 重量(KG)
            volume: 0, // 体积
            TotalNumberPieces: '', //  总件数
            totalParcelDeclaredWeight: undefined, //  包裹总重量（kg）
            totalParcelDeclaredVolume: undefined, //  包裹总体积（m³）
            invoiceNumber: '', // 发票号
            invoiceSerialNumber: '', // 发票序列号
            invoiceIssueDate: '', // 开票日期
            invoiceAccessKey: '', // 发票密钥
            scanOrderNumber: '', // 扫描单号
            invoiceMoney: '', // 开票金额
            waybillType: 'goods',
            tradeType: 1, // 交易类型
            exchangeOrder: false,
            hasBack: false,
            packageType: [
              // 包裹类型
              { code: this.$t('placeOrder.package'), value: 'package' },
              { code: this.$t('orderCenterCont.commodity'), value: 'goods' },
              { code: this.$t('orderCenterCont.gift'), value: 'gift' },
              { code: this.$t('orderCenterCont.file'), value: 'file' },
              { code: this.$t('orderCenterCont.other'), value: 'other' }
            ], // 当前选择包裹类型
            orderItemList: [
              {
                id: 0,
                name: '', // 物品名称 / 产品名称
                declaredValue: '', // 输入的单价 / 产品单价
                declaredWeight: null,
                quantity: '', // 数量
                length: 0, // 长
                width: 0, // 宽
                height: 0, // 高
                // invoice: [], // 商品发票证明
                // invoiceName: '' // 发票名
                sku: '' // 产品SKU代码
              }
            ]
          }
        ]
      },
      ulLi: 1,
      customerList: [], // 客户列表
      senderStateList: [], // 州列表
      senderCityList: [], // 发件人市列表
      receiveCityList: [], // 收件人城市
      receiverInfoParams: {
        // 收
        receiveName: '', // （收/发）名字
        receiveMobile: '', // 电话
        receiveTax: '', // 税号
        receiveMail: '', // 邮箱
        receiveZipcode: '', // 邮编
        receiveStreet: '', // 街道（精确到街道号）
        // receiveNeighborhood: '', // 邻里
        receiveAddress: '', // 详细地址
        receiveHouseNumber: '', // 门牌号
        receiveState: '', // 州
        receiveCity: '', // 城市
        receiveArea: '', // 区
        receiveIeNumber: '',
        receiveComplement: '', // 地址补充
        receivePhone: '' // 收件人电话
      },
      senderInfoParams: {
        // 发
        senderName: '', // （收/发）名字
        senderMobile: '', // 电话
        senderTax: '', // 税号
        senderMail: '', // 邮箱
        senderZipcode: '', // 邮编
        senderStreet: '', // 街道（精确到街道号）
        // senderNeighborhood: '', // 邻里
        senderAddress: '', // 详细地址
        senderHouseNumber: '', // 门牌号
        senderState: '', // 州
        senderCity: '', // 城市
        senderArea: '', // 区
        senderIeNumber: '', // 国家注册号
        senderComplement: '', // 地址补充
        senderPhone: '' // 发件人电话
      },
      isZipcode1: true, // 光标离开校验邮编-发件人
      isZipcode2: true, // 光标离开校验邮编-收件人
      isBlur: 0, // 光标移出 0 未移出不调用事件  1 已移出
      isCN: 0, // 客户单号是否验证成功
      isFlage1: false, // 是否发送下单请求
      isFlage2: false, // 是否发送下单请求
      isFlage3: false, // 是否发送下单请求
      isFlage4: false, // 是否发送下单请求
      isFlage5: false,
      isZipCode: [
        { required: true, message: this.$t('placeOrder.pleaseInput'), trigger: ['blur', 'change'] },
        { validator: isZipCodexiaodan, trigger: ['blur'] }
      ],
      isZipCodeSender: [
        { required: true, message: this.$t('placeOrder.pleaseInput'), trigger: ['blur', 'change'] },
        { validator: isZipCodexiaodanSender, trigger: ['blur'] }
      ],
      checkFloatNumber: [
        { required: true, message: this.$t('placeOrder.pleaseInput'), trigger: ['blur', 'change'] },
        {
          validator: (rule, value, callback) => {
            if (checkFloatNumber(value) !== true) {
              if (checkFloatNumber(value) === 1) {
                return callback(new Error(this.$t('placeOrder.beyondRange')));
              } else {
                return callback(new Error(this.$t('placeOrder.float2Number')));
              }
            } else {
              callback();
            }
          }
        }
      ],
      checkFloatNumber1: [
        { required: true, message: this.$t('placeOrder.pleaseInput'), trigger: ['blur', 'change'] },
        { validator: priceOfGoods, trigger: ['blur', 'change'] }
      ],
      // 开票金额校验
      InvoiceAmountRule: [
        { required: true, message: this.$t('placeOrder.pleaseInput'), trigger: ['blur', 'change'] },
        { validator: InvoiceAmounts, trigger: ['blur', 'change'] }
      ],
      // 地址补充
      addressComplement: [
        { required: false },
        { validator: checkAddressComplement, trigger: ['blur', 'change'] }
      ],
      // 公用限制
      only50Value: [
        { required: false },
        {
          validator: (rule, value, callback) => {
            if (!value) {
              return callback();
            }
            if (value.length > 50) {
              return callback(new Error(this.$t('placeOrder.input50Str')));
            } else {
              return callback();
            }
          },
          trigger: ['blur', 'change']
        }
      ],
      // 邮箱 E_Mail
      checkMail: [{ required: false }, { validator: E_Mail, trigger: ['blur', 'change'] }],
      // 城市
      cityComplement: [
        { required: true, message: this.$t('placeOrder.pleaseInput'), trigger: ['blur', 'change'] },
        { validator: checkCityComplement, trigger: ['blur', 'change'] }
      ],
      // 校验50个字符
      checkStr50: [
        { required: true, message: this.$t('placeOrder.pleaseInput'), trigger: ['blur', 'change'] },
        {
          validator: (rule, value, callback) => {
            if (value.trim().length === 0) {
              return callback(new Error(this.$t('placeOrder.pleaseInput')));
            } else if (value.length > 50) {
              return callback(new Error(this.$t('placeOrder.input50Str')));
            } else {
              callback();
            }
          },
          trigger: ['blur', 'change']
        }
      ],
      // 校验5个字符
      checkStr5: [
        { required: false },
        { min: 1, max: 5, message: this.$t('placeOrder.input5'), trigger: ['blur', 'change'] }
      ],
      // 校验20个字符
      checkStr20: [
        { required: false },
        { min: 1, max: 20, message: this.$t('placeOrder.input20'), trigger: ['blur', 'change'] }
      ],
      isNumber: [
        { required: true, message: this.$t('placeOrder.pleaseInput'), trigger: ['blur', 'change'] },
        {
          validator: (rule, value, callback) => {
            if (isNumber(value) !== true) {
              if (isNumber(value) === 1) {
                return callback(new Error(this.$t('placeOrder.beyondRangeNumber')));
              } else {
                return callback(new Error(this.$t('placeOrder.pleaseInput')));
              }
            } else {
              callback();
            }
          }
        }
      ],
      isPhone: [
        { required: true, message: this.$t('placeOrder.pleaseInput'), trigger: ['blur', 'change'] },
        { validator: MobilePhoneNumber, trigger: ['blur', 'change'] }
      ],
      IeNumber: [
        { required: true, message: this.$t('placeOrder.pleaseInput'), trigger: ['blur', 'change'] },
        { validator: IENumber, trigger: ['blur', 'change'] }
      ],
      IeNumber1: [{ required: false }, { validator: IENumber, trigger: ['blur', 'change'] }],
      isTax12: [
        // 112125456431
        {
          required: true,
          message: this.$t('newOrder.TheTaxIDCannotBeEmpty'),
          trigger: ['blur', 'change']
        },
        { validator: checkCNPJ, trigger: ['blur', 'change'] }
      ],
      zhDate: 'yyyy-MM-dd',
      ptDate: 'dd-MM-yyyy',
      iceSerialIndex: [
        // 112125456431
        {
          required: true,
          message: this.$t('placeOrder.PleaseEnter1To8invoiceSerialIndex'),
          trigger: ['blur', 'change']
        },
        { validator: invoiceSerialIndex, trigger: ['blur', 'change'] }
      ],
      pickerOptions: {
        disabledDate(time) {
          const curDate = new Date().getTime();
          const three = 180 * 24 * 3600 * 1000;
          const threeMonths = curDate - three;
          return time.getTime() > Date.now() - 8.64e6 || time.getTime() < threeMonths;
        }
      },
      invoiceNumber: [
        {
          required: true,
          message: this.$t('placeOrder.PleaseEnter6To16DigitInvoiceNumber'),
          trigger: ['blur', 'change']
        },
        { validator: invoiceNumberCheck, trigger: ['blur', 'change'] }
      ],
      invoiceKey: [
        {
          required: true,
          message: this.$t('placeOrder.PleaseEnter1To64DigitInvoiceNumber'),
          trigger: ['blur', 'change']
        },
        { validator: invoiceSeriakey, trigger: ['blur', 'change'] }
      ],
      // 总件数校验
      totalNumberPieces: [
        {
          required: true,
          validator: quantityVerification,
          int: 1,
          min: 1,
          max: 999,
          length: 0,
          trigger: ['blur']
        }
        // { validator: quantityVerification, int: 1, min: 1, max: 999, length: 0, trigger: ['blur'] }
      ],
      // 包裹总重量校验
      pesoTotal: [
        {
          required: true,
          validator: quantityVerification,
          int: 2,
          min: 0.001,
          max: 9999,
          length: 3,
          trigger: ['blur']
        }
        // { validator: quantityVerification, int: 2, min: 0.001, max: 9999, length: 3, trigger: ['blur'] }
      ],
      // 包裹总体积校验
      parcelVolume: [
        {
          required: true,
          validator: quantityVerification,
          int: 2,
          min: 0.001,
          max: 999,
          length: 3,
          trigger: ['blur']
        }
        // { validator: quantityVerification, int: 2, min: 0.001, max: 999, length: 3, trigger: ['blur'] }
      ],
      dateName: '',
      commercialList: [], // 商户列表
      timer: 0,
      isOpenDetailWindow: false,
      clickDetail: null,
      totalKey: new Date().getTime(),
      totalFormKey: new Date().getTime(),
      copyPackageData: null,
      showCopyPackageWindow: false,
      copyForm: {
        totalPackageNum: 0,
        totalPackageWeight: 0,
        totalPackageVolume: 0,
        copyPackageNum: null
      },
      copyNumData: null,
      copyIndex: null,
      copyNumber,
      stateTwoCode: '',
      customerObj: {}
    };
  },
  computed: {
    moreVal() {
      return {
        val1: this.baseRuleForm.customerId,
        val2: this.baseRuleForm.orderPackageType,
        val3: this.receiverInfoParams.receiveZipcode,
        val4: this.senderInfoParams.senderZipcode,
        val5: this.baseRuleForm.cargoType,
        val6: this.baseRuleForm.expressType
      };
    },

    // 提取所有 orderItemList 组成新数组
    allOrderItems() {
      return this.orderPackageListInfo.orderWaybillList.map((item) => item.orderItemList);
    }
  },

  watch: {
    orderDialog: {
      handler: function(val) {
        this.$refs['ruleForm']?.resetFields();
        this.WaybillNumber = '';
        this.tableData = [];
      }
    },
    addressDialog: {
      handler: function(val, oldVal) {
        if (val) {
          this.getSearchAddress();
        }
      }
    },
    'baseRuleForm.customerId': {
      handler: function(val, oldVal) {
        if (val) {
          this.isSync = false;
          this.customeGetSkuAndName();
        }
      },
      immediate: true
    },
    'orderPackageListInfo.totalParcel': {
      handler(newVal, oldVal) {
        this.computational();
        if (this.orderPackageListInfo.detailList.length > 0) {
          let total = 0;
          this.orderPackageListInfo.detailList.map((item) => {
            total += Number(item.quantity);
          });
          if (newVal < total) {
            let parcel = 0;
            this.$message.warning(this.$t('placeOrder.TheTotalNumberItemsCannotReduced'));
            this.orderPackageListInfo.detailList.map((item) => {
              parcel += Number(item.quantity);
            });
            this.$set(this.orderPackageListInfo, 'totalParcel', parcel);
            this.totalKey = new Date().getTime();
          }
        }
      },
      immediate: true
    },
    'orderPackageListInfo.totalParcelDeclaredWeight': {
      handler(newVal, oldVal) {
        this.computational();
        if (this.orderPackageListInfo.detailList.length > 0) {
          let total = 0;
          this.orderPackageListInfo.detailList.map((item) => {
            total += Number(item.unitWeight) * Number(item.quantity);
          });
          total = total.toFixed(3);
          if (newVal < total) {
            let weight = 0;
            this.$message.warning(this.$t('placeOrder.TheTotalWeightItemsCannotReduced'));
            this.orderPackageListInfo.detailList.map((item) => {
              weight += Number(item.unitWeight) * Number(item.quantity);
            });
            weight = weight.toFixed(3);
            this.$set(this.orderPackageListInfo, 'totalParcelDeclaredWeight', weight);
            this.totalKey = new Date().getTime();
          }
        }
      },
      immediate: true
    },
    'orderPackageListInfo.totalParcelDeclaredVolume': {
      handler(newVal, oldVal) {
        this.computational();
        if (this.orderPackageListInfo.detailList.length > 0) {
          let total = 0;
          this.orderPackageListInfo.detailList.map((item) => {
            total += Number(item.unitVolume) * Number(item.quantity);
          });
          total = total.toFixed(3);
          if (newVal < total) {
            let volume = 0;
            this.$message.warning(this.$t('placeOrder.TheTotalVolumeItemsCannotReduced'));
            this.orderPackageListInfo.detailList.map((item) => {
              volume += Number(item.unitVolume) * Number(item.quantity);
            });
            volume = volume.toFixed(3);
            this.$set(this.orderPackageListInfo, 'totalParcelDeclaredVolume', volume);
            this.totalKey = new Date().getTime();
          }
        }
      },
      immediate: true
    },
    moreVal: {
      handler(newVal, oldVal) {
        this.computational();
      },
      immediate: true,
      deep: true
    },
    allOrderItems: {
      handler(newVal, oldVal) {
        console.log('orderItemList 变化:', newVal);
        this.computational();
      },
      deep: true // 需深度监听数组内部变化
    },
    // 实时截取四个地址相关字段到50字符以内
    'senderInfoParams.senderArea'(newVal) {
      if (newVal && newVal.length > 50) {
        this.$set(this.senderInfoParams, 'senderArea', newVal.substring(0, 50));
      }
    },
    'senderInfoParams.senderStreet'(newVal) {
      if (newVal && newVal.length > 50) {
        this.$set(this.senderInfoParams, 'senderStreet', newVal.substring(0, 50));
      }
    },
    'senderInfoParams.senderHouseNumber'(newVal) {
      if (newVal && newVal.length > 20) {
        this.$set(this.senderInfoParams, 'senderHouseNumber', newVal.substring(0, 20));
      }
    },
    'senderInfoParams.senderComplement'(newVal) {
      if (newVal && newVal.length > 50) {
        this.$set(this.senderInfoParams, 'senderComplement', newVal.substring(0, 50));
      }
    },
    'receiverInfoParams.receiveArea'(newVal) {
      if (newVal && newVal.length > 50) {
        this.$set(this.receiverInfoParams, 'receiveArea', newVal.substring(0, 50));
      }
    },
    'receiverInfoParams.receiveStreet'(newVal) {
      if (newVal && newVal.length > 50) {
        this.$set(this.receiverInfoParams, 'receiveStreet', newVal.substring(0, 50));
      }
    },
    'receiverInfoParams.receiveHouseNumber'(newVal) {
      if (newVal && newVal.length > 20) {
        this.$set(this.receiverInfoParams, 'receiveHouseNumber', newVal.substring(0, 20));
      }
    },
    'receiverInfoParams.receiveComplement'(newVal) {
      if (newVal && newVal.length > 50) {
        this.$set(this.receiverInfoParams, 'receiveComplement', newVal.substring(0, 50));
      }
    }
  },
  created() {
    const date = new Date();
    const yy = date.getFullYear();
    const mm = date.getMonth() + 1;
    const dd = date.getDate();
    this.dateName =
      yy + '-' + (mm < 10 ? '0' + mm : mm) + '-' + (dd < 10 ? '0' + dd : dd) + ' 00:00:00';
    this.orderPackageListInfo.orderWaybillList[0].invoiceIssueDate = this.dateName;
    this.InvoiceInfoForm.invoiceIssueDate = this.dateName;
    this.getCustomerPage();
    this.getAddress();
  },
  methods: {
    handleCNPJ(val, flag) {
      if (flag === 1) {
        this.senderInfoParams.senderTax = orderCNPJ(val);
      } else {
        this.receiverInfoParams.receiveTax = orderCNPJ(val);
      }
    },
    showPriceInquiry() {
      this.isPriceInquiry = true;
    },
    closePriceInquiry() {
      this.isPriceInquiry = false;
    },
    // 关闭复制包裹弹窗
    closeCopyPackageWindow() {
      this.$refs.copyFormRef.resetFields();
    },
    // 判断小数点位数
    getDecimalPlaces(num) {
      if (Math.floor(num) === num) {
        return 0;
      }
      const str = num.toString().toLowerCase();
      if (str.indexOf('e-') !== -1) {
        const parts = str.split('e-');
        return parseInt(parts[1], 10) + (parts[0].split('.')[1] ? parts[0].split('.')[1].length : 0);
      }
      if (str.indexOf('.') !== -1) {
        return str.split('.')[1].length;
      }
      return 0;
    },
    // 确定复制包裹
    confirmCopy() {
      this.$refs.copyFormRef.validate((valid) => {
        if (valid) {
          for (let i = 0; i < this.copyForm.copyPackageNum; i++) {
            this.orderPackageListInfo.orderWaybillList.splice(
              this.copyIndex + 1,
              0,
              cloneDeep(this.copyPackageData)
            );
          }
          this.showCopyPackageWindow = false;
        }
      });
      if (this.baseRuleForm.cargoType === 1) {
        this.resetChargeCarriage();
      }
    },
    // 大件复制包裹
    async copyPackage(index) {
      this.copyIndex = index;
      const validateFields = [
        `orderWaybillList.${index}.weight`,
        `orderWaybillList.${index}.volume`
      ];
      this.orderPackageListInfo.orderWaybillList[index].orderItemList.forEach((item, indexItem) => {
        validateFields.push(`orderWaybillList.${index}.orderItemList.${indexItem}.sku`);
        validateFields.push(`orderWaybillList.${index}.orderItemList.${indexItem}.name`);
        validateFields.push(`orderWaybillList.${index}.orderItemList.${indexItem}.declaredValue`);
        validateFields.push(`orderWaybillList.${index}.orderItemList.${indexItem}.quantity`);
      });
      const errorMessageList = [];
      await this.$refs.packageRuleForm.validateField(validateFields, (errorMessage) => {
        if (errorMessage) {
          errorMessageList.push(errorMessage);
        }
      });
      if (errorMessageList.length > 0) {
        return;
      }
      let totalWeight = 0;
      let totalVolume = 0;
      this.orderPackageListInfo.orderWaybillList.map((item) => {
        totalWeight = Number(item.weight) + totalWeight;
        totalVolume = Number(item.volume) + totalVolume;
      });
      this.copyPackageData = cloneDeep(this.orderPackageListInfo.orderWaybillList[index]);
      this.copyPackageData.scanOrderNumber = '';
      this.copyForm.totalPackageNum = this.orderPackageListInfo.orderWaybillList.length;
      this.copyForm.totalPackageWeight =
        this.getDecimalPlaces(totalWeight) > 4 ? Number(totalWeight.toFixed(4)) : totalWeight;
      this.copyForm.totalPackageVolume =
        this.getDecimalPlaces(totalVolume) > 4 ? Number(totalVolume.toFixed(4)) : totalVolume;
      this.copyForm.copyPackageNum = null;
      this.copyNumData = cloneDeep(this.copyForm);
      this.showCopyPackageWindow = true;
    },
    // 修改复制数量
    changeCopyPackageNum(val) {
      const totalPackageWeight =
        this.copyNumData.totalPackageWeight + this.copyPackageData.weight * Number(val);
      const totalPackageVolume =
        this.copyNumData.totalPackageVolume + this.copyPackageData.volume * Number(val);
      this.copyForm.totalPackageNum = this.copyNumData.totalPackageNum + Number(val);
      this.copyForm.totalPackageWeight =
        this.getDecimalPlaces(totalPackageWeight) > 4
          ? Number(totalPackageWeight.toFixed(4))
          : totalPackageWeight;
      this.copyForm.totalPackageVolume =
        this.getDecimalPlaces(totalPackageVolume) > 4
          ? Number(totalPackageVolume.toFixed(4))
          : totalPackageVolume;
    },
    handleScanOrderNumberChange() {
      this.$nextTick(() => {
        this.orderPackageListInfo.orderWaybillList.forEach((item, index) => {
          const fieldName = `orderWaybillList.${index}.scanOrderNumber`;
          this.$refs.packageRuleForm.validateField(fieldName);
        });
      });
    },
    validateScanOrderNumber(rule, value, callback) {
      if (!value) {
        return callback();
      }
      // 检查当前输入的扫描单号在其他包裹中是否已存在
      const currentIndex = rule.index;
      const duplicate = this.orderPackageListInfo.orderWaybillList.some((item, index) => {
        return index !== currentIndex && item.scanOrderNumber === value;
      });
      if (duplicate) {
        callback(new Error(this.$t('collectionCenter.scanNumberNoDuplicate')));
      } else {
        callback();
      }
    },
    customeGetSkuAndName() {
      if (!this.baseRuleForm.customerId) {
        this.$message.error(this.$t('placeOrder.pleaseChooseClient'));
        return;
      }
      const load = Loading.service({
        fullscreen: true,
        lock: true,
        spinner: 'el-icon-loading',
        text: this.$t('collectionCenter.loading'),
        background: 'rgba(250, 250, 250, 0.6)'
      });
      const form = {
        customerId: this.baseRuleForm.customerId
      };
      skuInfoOptionSelect(form)
        .then((res) => {
          if (res.code === 200 && res.data.length > 0) {
            this.skuAndNameOptions = res.data;
          } else {
            this.skuAndNameOptions = [];
          }
        })
        .finally(() => {
          load.close();
        });
    },
    getSkuAndName(typeVal, index, goodIndex, val) {
      if (typeVal === 'sku') {
        const selectedItem = this.skuAndNameOptions.find((item) => item.skuCode === val);
        this.orderPackageListInfo.orderWaybillList[index].orderItemList[goodIndex].name =
          selectedItem.productName;
      }
      if (typeVal === 'name') {
        const selectedItem = this.skuAndNameOptions.find((item) => item.productName === val);
        this.orderPackageListInfo.orderWaybillList[index].orderItemList[goodIndex].sku =
          selectedItem.skuCode;
      }
      const currentItem = this.orderPackageListInfo.orderWaybillList[index].orderItemList[goodIndex];
      if (
        currentItem.declaredValue !== undefined &&
        currentItem.declaredValue !== '' &&
        currentItem.quantity !== undefined &&
        currentItem.quantity !== ''
      ) {
        this.calculatePackageWeightAndVolume();
      }
    },
    // 货物类型为大件时，计算逻辑更改：
    calculatePackageWeightAndVolume() {
      setTimeout(() => {
        // 包裹
        this.orderPackageListInfo.orderWaybillList.forEach((packageItem, idx) => {
          let totalWeight = 0;
          let totalVolume = 0;
          // 商品
          packageItem.orderItemList.forEach((itemGood) => {
            const currentSku = itemGood.sku;
            const currentName = itemGood.name;
            let selectedSku = null;
            if (currentSku) {
              selectedSku = this.skuAndNameOptions.find((option) => option.skuCode === currentSku);
            }
            if (!selectedSku && currentName) {
              selectedSku = this.skuAndNameOptions.find(
                (option) => option.productName === currentName
              );
            }

            const quantity = Number(itemGood.quantity) || 0;

            // 计算重量和体积
            if (selectedSku) {
              totalWeight += (Number(selectedSku.grossWeight) || 0) * quantity;
              totalVolume += (Number(selectedSku.dimension) || 0) * quantity;
            }
          });
          this.orderPackageListInfo.orderWaybillList[idx].weight = this.processValue(totalWeight, 4);
          this.orderPackageListInfo.orderWaybillList[idx].volume = this.processValue(totalVolume, 4);
        });
        if (this.baseRuleForm.cargoType === 1) {
          this.resetChargeCarriage();
        }
      }, 1000);
    },
    processValue(value, decimals = 4) {
      // 有小数点后超过4位的，就进行四舍五入，否则不需要使用四舍五入
      if (value === null || value === undefined) return 0;
      const numValue = Number(value);
      if (isNaN(numValue)) return 0;
      const stringValue = numValue.toString();
      const parts = stringValue.split('.');
      if (parts.length < 2 || parts[1].length <= decimals) {
        return numValue;
      } else {
        const multiplier = Math.pow(10, decimals);
        return Math.round(numValue * multiplier) / multiplier;
      }
    },
    // 重新计算预估运费
    async resetChargeCarriage() {
      let sum = 0; // 重量
      let volume = 0; // 体积
      let count = 0; // 申报价值

      this.orderPackageListInfo.orderWaybillList.map((item) => {
        sum += Number(item.weight) || 0;
        volume += Number(item.volume) || 0;
        sum = this.processValue(sum, 4);
        volume = this.processValue(volume, 4);
        return {
          sum,
          volume
        };
      });
      const allDeclaredValues = this.orderPackageListInfo.orderWaybillList.reduce(
        (total, goodsItem) => {
          if (goodsItem.orderItemList) {
            const packageTotal = goodsItem.orderItemList.reduce((packageSum, item) => {
              return (
                packageSum + (Number(item.declaredValue) || 0) * 100 * (Number(item.quantity) || 0)
              );
            }, 0);
            return total + packageTotal;
          }
          return total;
        },
        0
      );
      count = allDeclaredValues / 100;
      this.totalParcelDeclaredWeight = sum;
      this.totalParcelDeclaredVolume = volume;

      const form = {
        customerId: this.baseRuleForm.customerId,
        weight: sum,
        volume: volume,
        amount: count,
        collectType: this.baseRuleForm.collectType, // 揽收类型
        orderPackageType: this.baseRuleForm.orderPackageType,
        receiveZipcode: this.receiverInfoParams.receiveZipcode,
        senderZipcode: this.senderInfoParams.senderZipcode,
        cargoType: this.baseRuleForm.cargoType,
        expressType: this.baseRuleForm.expressType,
        providerInfoId: '',
        invoiceMoney: 0
      };
      if (this.baseRuleForm.cargoType === 1) {
        // 大件时，volume需要处理为m³数
        form.volume = form.volume * 1000000;
        form.invoiceMoney = this.InvoiceInfoForm.invoiceMoney;
      } else {
        let money = 0;
        this.orderPackageListInfo.orderWaybillList.forEach((item) => {
          // 将item.invoiceMoney转为数字后再累加（处理可能的字符串或其他类型）
          money += Number(item.invoiceMoney) || 0;
        });
        form.invoiceMoney = money;
      }
      let isTrue = true;
      for (const prop in form) {
        // eslint-disable-next-line no-prototype-builtins
        if (form.hasOwnProperty(prop) && prop !== 'providerInfoId') {
          if (form[prop] === null || form[prop] === undefined || form[prop] === '') {
            isTrue = false;
          }
        }
      }
      if (isTrue) {
        // 仅考虑大件
        if (this.baseRuleForm.cargoType === 1) {
          try {
            await this.getBigFreightWeight();
            form.weight = this.billableWeight;
          } catch (e) {
            console.log('计费重量 失败', e);
            return;
          }
        }
      }
      if (isTrue) {
        queryCalculateFee(form)
          .then((res) => {
            if (res.code === 200) {
              this.forecastNumber = res.data.totalFee;
            } else {
              this.forecastNumber = '';
            }
          })
          .catch(() => {
            this.forecastNumber = '';
          });
      } else {
        this.forecastNumber = '';
      }
    },

    // 通过邮编获取发件人地址信息
    zipcodeSendChange(zipcode) {
      if (zipcode) {
        getAddressByZipCode(zipcode).then((res) => {
          console.log(res, '===res');
          if (res.code === 200 && res.data) {
            if (res.data.state) {
              this.senderInfoParams.senderState = res.data.state;
            }
            if (res.data.city) {
              this.senderInfoParams.senderCity = res.data.city;
            }
            if (res.data.area) {
              this.senderInfoParams.senderArea = res.data.area;
            }
            if (res.data.street) {
              this.senderInfoParams.senderStreet = res.data.street;
            }
            if (res.data.houseNumber) {
              this.senderInfoParams.senderHouseNumber = res.data.houseNumber;
            }
            if (this.senderInfoParams.senderAddress) {
              return;
            }
            if (res.data.formattedAddress) {
              this.senderInfoParams.senderAddress = res.data.formattedAddress;
            }
          }
        });
      }
    },
    // 通过邮编获取收件人地址信息
    zipcodeReceiveChange(zipcode) {
      if (zipcode) {
        getAddressByZipCode(zipcode).then((res) => {
          console.log(res, '===res');
          if (res.code === 200 && res.data) {
            if (res.data.state) {
              this.receiverInfoParams.receiveState = res.data.state;
            }
            if (res.data.city) {
              this.receiverInfoParams.receiveCity = res.data.city;
            }
            if (res.data.area) {
              this.receiverInfoParams.receiveArea = res.data.area;
            }
            if (res.data.street) {
              this.receiverInfoParams.receiveStreet = res.data.street;
            }
            if (res.data.houseNumber) {
              this.receiverInfoParams.receiveHouseNumber = res.data.houseNumber;
            }
            if (this.receiverInfoParams.receiveAddress) {
              return;
            }
            if (res.data.formattedAddress) {
              this.receiverInfoParams.receiveAddress = res.data.formattedAddress;
            }
          }
        });
      }
    },
    computational() {
      if (this.baseRuleForm.cargoType !== 1) {
        debounceHandle(() => {
          this.chargeCarriage();
        }, 1000);
      }
    },
    // 预估运费
    chargeCarriage() {
      let sum = 0; // 重量
      let volume = 0; // 体积
      let count = 0; // 申报价值

      // 计算申报价值
      const calculateDeclaredValue = (orderItems) => {
        return orderItems.reduce((acc, cur) => {
          return acc + cur.declaredValue * 100 * cur.quantity;
        }, 0);
      };

      if (this.baseRuleForm.cargoType === 0) {
        this.orderPackageListInfo.orderWaybillList.forEach((arr) => {
          const [length, width, height] = ['length', 'width', 'height'].map((key) =>
            Number(arr[key] || 0)
          );

          volume += length * width * height;
          sum += Number(arr.weight || 0);
          count += arr.orderItemList ? calculateDeclaredValue(arr.orderItemList) : 0;
        });

        count /= 100;
      } else {
        volume = Number(this.orderPackageListInfo.totalParcelDeclaredVolume || 0) * 1e6;
        sum = Number(this.orderPackageListInfo.totalParcelDeclaredWeight || 0);

        // 批量计算所有包裹声明价值
        const allDeclaredValues = this.orderPackageListInfo.orderWaybillList
          .filter((arr) => arr.orderItemList)
          .flatMap((arr) => arr.orderItemList)
          .reduce((acc, cur) => acc + cur.declaredValue * 100 * cur.quantity, 0);

        count = (allDeclaredValues / 100) * this.orderPackageListInfo.totalParcel;
      }
      console.log(volume, '===volume');
      console.log(sum, '===sum');
      console.log(count, '===count');
      const form = {
        customerId: this.baseRuleForm.customerId,
        weight: sum,
        volume: volume,
        amount: count,
        collectType: this.baseRuleForm.collectType, // 揽收类型
        orderPackageType: this.baseRuleForm.orderPackageType,
        receiveZipcode: this.receiverInfoParams.receiveZipcode,
        senderZipcode: this.senderInfoParams.senderZipcode,
        cargoType: this.baseRuleForm.cargoType,
        expressType: this.baseRuleForm.expressType,
        providerInfoId: '',
        invoiceMoney: 0
      };
      if (this.baseRuleForm.cargoType === 1) {
        // 大件时，volume需要处理为m³
        form.volume = form.volume * 1000000;
        form.invoiceMoney = this.InvoiceInfoForm.invoiceMoney;
      } else {
        let money = 0;
        this.orderPackageListInfo.orderWaybillList.forEach((item) => {
          // 将item.invoiceMoney转为数字后再累加（处理可能的字符串或其他类型）
          money += Number(item.invoiceMoney) || 0;
        });
        form.invoiceMoney = money;
      }
      console.log(form, '=====form');
      let isTrue = true;
      for (const prop in form) {
        // eslint-disable-next-line no-prototype-builtins
        if (form.hasOwnProperty(prop) && prop !== 'providerInfoId') {
          if (form[prop] === null || form[prop] === undefined || form[prop] === '') {
            isTrue = false;
          }
        }
      }
      if (isTrue) {
        // console.log(form, '=====form');

        queryCalculateFee(form)
          .then((res) => {
            if (res.code === 200) {
              this.forecastNumber = res.data.totalFee;
            } else {
              this.forecastNumber = '';
            }
          })
          .catch(() => {
            this.forecastNumber = '';
          });
      } else {
        this.forecastNumber = '';
      }
    },
    // 货物类型切换
    cargoTypeChange(val) {
      if (val === 0) {
        this.InvoiceInfoForm = {
          invoiceIssueDate: '',
          invoiceMoney: '',
          invoiceNumber: '',
          invoiceSerialNumber: '',
          invoiceAccessKey: ''
        };
      }
      // console.log(val, '货物类型切换');
      this.orderPackageListInfo.totalParcelDeclaredVolume = undefined;
      this.orderPackageListInfo.totalParcelDeclaredWeight = undefined;
      this.orderPackageListInfo.totalParcel = 1;
      this.orderPackageListInfo.detailList = [];
      this.orderPackageListInfo.orderWaybillListNew = [];
      this.baseRuleForm.paymentType = null;
      const data = [];
      let orderItemList = [];
      if (this.baseRuleForm.cargoType === 1) {
        orderItemList = [
          {
            sku: '', // 产品SKU代码
            name: '', // 产品名称
            declaredValue: '', // 产品单价
            declaredWeight: null,
            quantity: '' // 数量
          }
        ];
      } else {
        orderItemList = [
          {
            name: '', // 物品名称
            declaredValue: '', // 输入的单价
            quantity: '' // 数量
          }
        ];
      }
      this.orderPackageListInfo.orderWaybillList.forEach((item) => {
        data.push({
          ...item,
          totalParcelDeclaredVolume: undefined,
          totalParcelDeclaredWeight: undefined,
          weight: 0,
          volume: 0,
          length: 0,
          width: 0,
          height: 0,
          TotalNumberPieces: null,
          orderItemList
          // orderItemList: [
          //   {
          //     id: 0,
          //     name: '', // 物品名称
          //     declaredValue: '', // 输入的单价
          //     declaredWeight: null,
          //     quantity: '', // 数量
          //     length: 0, // 长
          //     width: 0, // 宽
          //     height: 0 // 高
          //     // invoice: [], // 商品发票证明
          //     // invoiceName: '' // 发票名
          //   }
          // ]
        });
      });
      this.$set(this.orderPackageListInfo, 'orderWaybillList', [data[0]]);
      this.baseRuleForm.collectType = '';
      if (val === 0) {
        this.baseRuleForm.orderPackageType = 1;
      } else if (val === 1) {
        this.baseRuleForm.orderPackageType = 4;
        this.baseRuleForm.collectType = '2';
      } else {
        this.baseRuleForm.orderPackageType = 1;
      }
    },
    // 打开补充详细体积、重量弹窗
    openDetailWindow() {
      this.clickDetail = cloneDeep(this.orderPackageListInfo);
      this.isOpenDetailWindow = true;
    },
    // 保存明细
    saveDetail() {
      this.$refs.openDetail.save();
    },
    getSaveDetail(data) {
      this.orderPackageListInfo.totalParcelDeclaredVolume = data.packageVolume;
      this.orderPackageListInfo.totalParcelDeclaredWeight = data.totalWeight;
      this.orderPackageListInfo.totalParcel = data.totalNumber;
      this.orderPackageListInfo.detailList = data.detailList;
      if (Number(data.totalNumber)) {
        this.orderPackageListInfo.orderWaybillListNew = [];
        for (let i = 0; i < data.detailList.length; i++) {
          const dataList = cloneDeep(data.orderWaybillList[0]);
          dataList.totalParcelDeclaredVolume = data.packageVolume;
          dataList.totalParcelDeclaredWeight = data.totalWeight;
          dataList.TotalNumberPieces = data.totalNumber;
          dataList.volume = data.detailList[i].unitVolume;
          dataList.weight = data.detailList[i].unitWeight;
          if (data.detailList[i].quantity > 1) {
            for (let j = 0; j < data.detailList[i].quantity; j++) {
              this.orderPackageListInfo.orderWaybillListNew.push(dataList);
            }
          } else {
            this.orderPackageListInfo.orderWaybillListNew.push(dataList);
          }
        }
      }
      this.orderPackageListInfo.orderWaybillList = [
        this.orderPackageListInfo.orderWaybillListNew[0]
      ];
      this.isOpenDetailWindow = false;
      this.totalFormKey = new Date().getTime();
    },
    // handleInputsenderTax() {
    //   this.senderInfoParams.senderTax = this.senderInfoParams.senderTax.replace(/[^\d]/g, ''); // 只保留数字
    // },
    // handleInputreceiveTax() {
    //   this.receiverInfoParams.receiveTax = this.receiverInfoParams.receiveTax.replace(/[^\d]/g, ''); // 只保留数字
    // },
    // 当前客户订单
    getCustomerNumber(customerNumber) {
      // 如果有客户单号，先验证客户单号
      if (this.baseRuleForm.customerNumber) {
        if (this.baseRuleForm.customerNumber.length < 2) {
          return;
        }
        const checkCustomerData = {
          customerNumber: this.baseRuleForm.customerNumber,
          customerId: this.baseRuleForm.customerId
        };
        // console.log('管理端校验接口', checkCustomerData);
        checkCustomerNumber(checkCustomerData).then((res) => {
          if (res.code === 200) {
            // 客户单号可用
            this.$message({
              message: this.$t('placeOrder.customerNumberUsable'),
              type: 'success'
            });
            this.isCN = 1;
          }
          if (res.status === 'ERROR') {
            this.isCN = 0;
            this.$message.error(res.msg);
          }
        });
      }
    },
    // 是否展示更多信息
    showSenderMore() {
      this.isShowSenderMoreInfo = !this.isShowSenderMoreInfo;
    },
    // 是否展示更多信息
    showRecipientMore() {
      this.isShowRecipientMoreInfo = !this.isShowRecipientMoreInfo;
    },
    // 添加商品
    addGoods(index) {
      let i = 0;
      if (this.baseRuleForm.cargoType === 1) {
        this.orderPackageListInfo.orderWaybillList[index].orderItemList.push({
          id: i++,
          sku: '', // 产品SKU代码
          name: '', // 产品名称
          declaredValue: '', // 产品单价
          declaredWeight: null,
          quantity: '' // 数量
        });
      } else {
        this.orderPackageListInfo.orderWaybillList[index].orderItemList.push({
          id: i++,
          name: '', // 物品名称
          declaredValue: '', // 输入的单价
          quantity: '' // 数量
          // invoice: [], // 商品发票证明
          // invoiceName: '' // 发票名
        });
      }
    },
    // 删除商品
    delGoods(index, goodIndex) {
      this.orderPackageListInfo.orderWaybillList[index].orderItemList.splice(goodIndex, 1);
      if (this.baseRuleForm.cargoType === 1) {
        this.calculatePackageWeightAndVolume();
      }
    },
    // 添加包裹
    addPackage() {
      let orderItemList = [];
      if (this.baseRuleForm.cargoType === 1) {
        orderItemList = [
          {
            sku: '', // 产品SKU代码
            name: '', // 产品名称
            declaredValue: '', // 产品单价
            declaredWeight: null,
            quantity: '' // 数量
          }
        ];
      } else {
        orderItemList = [
          {
            name: '', // 物品名称
            declaredValue: '', // 输入的单价
            quantity: '' // 数量
            // invoice: [], // 商品发票证明
            // invoiceName: '' // 发票名
          }
        ];
      }
      this.orderPackageListInfo.orderWaybillList.push({
        dictName: 'WRPER1',
        tradeType: 1, // 交易类型
        length: 0, // 长
        width: 0, // 宽
        height: 0, // 高
        weight: 0, // 重量(KG)
        TotalNumberPieces: '', //  总件数
        totalParcelDeclaredWeight: undefined, //  包裹总重量（kg）
        totalParcelDeclaredVolume: undefined, //  包裹总体积（m³）
        invoiceNumber: '', // 发票号
        invoiceSerialNumber: '', // 发票序列号
        invoiceIssueDate: this.dateName, // 开票日期
        invoiceAccessKey: '', // 发票密钥
        invoiceMoney: '', // 开票金额
        waybillType: 'goods',
        packageType: [
          // 包裹类型
          { code: this.$t('placeOrder.package'), value: 'package' },
          { code: this.$t('orderCenterCont.commodity'), value: 'goods' },
          { code: this.$t('orderCenterCont.gift'), value: 'gift' },
          { code: this.$t('orderCenterCont.file'), value: 'file' },
          { code: this.$t('orderCenterCont.other'), value: 'other' }
        ], // 当前选择包裹类型
        orderItemList, // 根据货物类型自定义
        scanOrderNumber: '',
        volume: 0
      });
    },
    // 删除包裹
    delPackage(bgIndex) {
      this.orderPackageListInfo.orderWaybillList.splice(bgIndex, 1);
      if (this.baseRuleForm.cargoType === 1) {
        this.resetChargeCarriage();
      }
    },
    // 滚动
    scrollTop(index) {
      this.ulLi = index;
      document.querySelector(`#box${this.ulLi}`).scrollIntoView({
        behavior: 'instant', // 平滑过渡
        block: 'start' // start 上边框  center 中间  end 底部边框 与视窗顶部平齐
      });
    },
    // 客户列表
    getCustomerPage(val) {
      const customerPageDate = {
        pageNumber: 1,
        pageSize: 10000,
        params: {
          company: '',
          source: '',
          username: ''
        }
      };
      CustomerPage(customerPageDate).then((res) => {
        // 只提取需要的字段，多余字段全部丢弃
        this.customerList = res.data.records.map((item) => ({
          id: item.id,
          username: item.username,
          calculationMethod: item.calculationMethod,
          useVolumeBilling: item.useVolumeBilling,
          calculateBase: item.calculateBase,
          state: item.state
        }));
      });
      if (val) {
        this.orderDialog = true;
      }
    },
    // 发件人——级联地区
    getAddress(name = '') {
      // level 0 州    1 城市   2 地区
      const params = {
        pageNumber: 1,
        pageSize: 200,
        params: {
          name,
          countryName: 'Brazil'
        }
      };
      selectState(params, false).then((res) => {
        if (res.code === 200) {
          this.senderStateList = res.data.records;
        }
      });
    },
    // 州省变化获取城市
    stateChangeOption(type) {
      let id = null;
      if (type === 1) {
        this.senderCityList = [];
        this.senderInfoParams.senderCity = '';
        this.senderStateList.map((item) => {
          if (item.shortName === this.senderInfoParams.senderState) {
            id = item.id;
          }
        });
      } else {
        this.receiveCityList = [];
        this.receiverInfoParams.receiveCity = '';
        this.senderStateList.map((item) => {
          if (item.shortName === this.receiverInfoParams.receiveState) {
            id = item.id;
          }
        });
      }
      const params = {
        pageNumber: 1,
        pageSize: 200,
        params: {
          id,
          name: ''
        }
      };
      selectCity(params, false).then((res) => {
        if (res.code === 200) {
          if (type === 1) {
            this.senderCityList = res.data.records;
          } else {
            this.receiveCityList = res.data.records;
          }
        }
      });
    },
    // 获取城市
    getSenderCity(name = '') {
      let id = null;
      this.senderStateList.map((item) => {
        if (item.shortName === this.senderInfoParams.senderState) {
          id = item.id;
        }
      });
      const params = {
        pageNumber: 1,
        pageSize: 200,
        params: {
          id,
          name
        }
      };
      selectCity(params, false).then((res) => {
        if (res.code === 200) {
          this.senderCityList = res.data.records;
        }
      });
    },
    getReceiveCity(name = '') {
      let id = null;
      this.senderStateList.map((item) => {
        if (item.shortName === this.receiverInfoParams.receiveState) {
          id = item.id;
        }
      });
      const params = {
        pageNumber: 1,
        pageSize: 200,
        params: {
          id,
          name
        }
      };
      selectCity(params, false).then((res) => {
        if (res.code === 200) {
          this.receiveCityList = res.data.records;
        }
      });
    },
    // 邮编校验
    checkPostcode(postcode, pType) {
      if (postcode.length === 0) {
        return;
      }
      // pType === 1 发件人   pType === 2 收件人
      if (this.isBlur === 1) {
        const data = {};
        data.zipcode = postcode;
        checkedzipcode(data)
          .then((res) => {
            // console.log('验证邮编', res);
            if (res.code === 200) {
              if (!res.data) {
                if (pType === 1) {
                  this.$message.error(this.$t('placeOrder.inputCodeErr'));
                  this.senderInfoParams.senderZipcode = '';
                }
                if (pType === 2) {
                  this.$message.error(this.$t('placeOrder.inputCodeErr'));
                  this.receiverInfoParams.receiveZipcode = '';
                }
              }
            }
          })
          .catch(() => {
            if (pType === 1) {
              this.senderInfoParams.senderZipcode = '';
            }
            if (pType === 2) {
              this.receiverInfoParams.receiveZipcode = '';
            }
          });
      }
    },
    // 大件计费重量
    getBigFreightWeight() {
      // 需要过滤包裹信息得出：总重量、总体积、开票金额
      let weightTotal = 0;
      let volumeTotal = 0;
      let invoiceMoneyTotal = 0;
      this.orderPackageListInfo.orderWaybillList.forEach((item) => {
        weightTotal += Number(item.weight);
        volumeTotal += Number(item.volume);
        invoiceMoneyTotal += Number(item.invoiceMoney);
      });
      const param = {
        cargoType: this.baseRuleForm.cargoType,
        orderPackageType: this.baseRuleForm.orderPackageType,
        expressType: this.baseRuleForm.expressType,
        customerId: this.baseRuleForm.customerId,
        senderZipcode: this.senderInfoParams.senderZipcode,
        receiveZipcode: this.receiverInfoParams.receiveZipcode,
        weight: weightTotal,
        volume: volumeTotal,
        length: '', // 空着
        width: '', // 空着
        height: '', // 空着
        invoiceMoney: invoiceMoneyTotal
      };
      return getBillableWeight(param).then((res) => {
        if (res.code === 200) {
          this.billableWeight = res.data;
          return res;
        } else {
          return Promise.reject(res);
        }
      });
    },
    // 下单
    async placeAnOrder() {
      this.$refs['baseRuleForm'].validate((valid) => {
        this.isFlage1 = !!valid;
      });
      this.$refs['packageRuleForm'].validate((valid) => {
        this.isFlage4 = !!valid;
      });
      const valid2 = await this.$refs['senderInfoForm'].validate();
      this.isFlage2 = valid2;
      const valid3 = await this.$refs['receiverInfoForm'].validate();
      this.isFlage3 = valid3;
      let valid5 = false;
      if (this.baseRuleForm.cargoType === 1) {
        valid5 = await this.$refs['InvoiceInfoRuleForm'].validate();
        this.isFlage5 = valid5;
      } else {
        this.isFlage5 = true;
      }
      if (this.isFlage1 && this.isFlage2 && this.isFlage3 && this.isFlage4 && this.isFlage5) {
        const param = cloneDeep(this.orderPackageListInfo);
        console.log(param, 'param');
        // 大件补充数据
        if (param.orderWaybillListNew && param.orderWaybillListNew.length > 0) {
          param.orderWaybillList = param.orderWaybillListNew;
          if (param.totalParcel > param.orderWaybillListNew.length) {
            const total = param.totalParcel - param.orderWaybillListNew.length;
            for (let i = 0; i < total; i++) {
              param.orderWaybillList.push({
                ...param.orderWaybillList[0],
                height: 0,
                length: 0,
                volume: 0,
                weight: 0,
                width: 0
              });
            }
          }
        }
        delete param.orderWaybillListNew;
        delete param.detailList;
        param.orderWaybillList.map((e) => {
          delete e.packageType;
          delete e.TotalNumberPieces;
          delete e.totalParcelDeclaredWeight;
          delete e.totalParcelDeclaredVolume;
        });
        // 深拷贝数据
        const receiverInfoParams = cloneDeep(this.receiverInfoParams);
        const senderInfoParams = cloneDeep(this.senderInfoParams);
        // 清理税号
        const cleanTax = (taxStr) => {
          if (!taxStr) return '';
          const pattern = /[A-Za-z0-9]+/g;
          const numbers = taxStr.match(pattern);
          return numbers ? numbers.join('') : '';
        };

        receiverInfoParams.receiveTax = cleanTax(receiverInfoParams.receiveTax);
        senderInfoParams.senderTax = cleanTax(senderInfoParams.senderTax);
        const data = {
          cargoType: this.baseRuleForm.cargoType, // 货物类型
          collectType: this.baseRuleForm.collectType,
          orderPackageType: this.baseRuleForm.orderPackageType,
          expressType: this.baseRuleForm.expressType,
          paymentType: this.baseRuleForm.cargoType === 1 ? 1 : null,
          currency: 'BRL', // 币种
          customerId: this.baseRuleForm.customerId,
          customerNumber: this.baseRuleForm.customerNumber, // 客户单号
          receiverInfoParams: receiverInfoParams,
          senderInfoParams: senderInfoParams,
          totalParcelDeclaredWeight: param.totalParcelDeclaredWeight,
          totalParcelDeclaredVolume: param.totalParcelDeclaredVolume,
          orderWaybillList: param.orderWaybillList
        };
        if (this.baseRuleForm.merchantNumber) {
          data.merchantNumber = this.baseRuleForm.merchantNumber;
          data.merchantName = this.baseRuleForm.merchantName;
        }
        console.log(param, 'param111111');
        if (param.orderWaybillList.length > 0) {
          for (let i = 0; i < param.orderWaybillList.length; i++) {
            // 加入发票信息
            if (data.cargoType === 1) {
              param.orderWaybillList[i].invoiceIssueDate = this.InvoiceInfoForm.invoiceIssueDate;
              param.orderWaybillList[i].invoiceMoney = this.InvoiceInfoForm.invoiceMoney;
              param.orderWaybillList[i].invoiceNumber = this.InvoiceInfoForm.invoiceNumber;
              param.orderWaybillList[i].invoiceSerialNumber =
                this.InvoiceInfoForm.invoiceSerialNumber;
              param.orderWaybillList[i].invoiceAccessKey = this.InvoiceInfoForm.invoiceAccessKey;
            }
            param.orderWaybillList[i].invoiceAccessKey = this.removeSpaces(
              param.orderWaybillList[i].invoiceAccessKey
            );
            // param.orderWaybillList[i].invoiceIssueDate =
            //   param.orderWaybillList[i].invoiceIssueDate + ' 00:00:00';
            const length = param.orderWaybillList[i].length;
            const height = param.orderWaybillList[i].height;
            const width = param.orderWaybillList[i].width;
            const weight = param.orderWaybillList[i].weight;
            const sum = Number(length) + Number(width) + Number(height);
            if (data.cargoType === 0) {
              if (Number(length) > 170 || Number(height) > 170 || Number(width) > 170) {
                this.$message.error(this.$t('GlobalSetObj.LWH'));
                return;
              }
              if (sum > 240) {
                this.$message.error(this.$t('GlobalSetObj.LWHSum'));
                return;
              }
              if (Number(weight) > 500) {
                this.$message.error(this.$t('GlobalSetObj.maximo500kg'));
                return;
              }
            }
          }
        }
        if (data.cargoType === 1) {
          data.totalParcelDeclaredWeight = this.totalParcelDeclaredWeight;
          data.totalParcelDeclaredVolume = this.totalParcelDeclaredVolume;
          // 只有：两个都不是 SP → 才报错
          if (this.stateTwoCode !== 'SP' && this.customerObj.state !== this.stateTwoCode) {
            this.$message.error(this.$t('placeOrder.zipCodeTip02'));
            return;
          }
        }
        if (data.cargoType === 1) {
          // 将总包裹货值与开票金额相比较，需要金额一致才允许下单，否-则提示：包裹产品价值与开票金额不一致，请检查产品单价
          // 总包裹货值：declaredValue * quantity总和
          // 开票金额：InvoiceInfoForm.invoiceMoney
          let totalDeclaredValue = param.orderWaybillList.reduce((total, waybillItem) => {
            if (waybillItem.orderItemList && waybillItem.orderItemList.length > 0) {
              const waybillTotal = waybillItem.orderItemList.reduce((waybillSum, orderItem) => {
                const declaredValue = orderItem.declaredValue || 0;
                const quantity = orderItem.quantity || 0;
                return waybillSum + declaredValue * quantity;
              }, 0);
              return total + waybillTotal;
            }
            return total;
          }, 0);
          totalDeclaredValue = parseFloat(totalDeclaredValue.toFixed(2));
          if (Number(this.InvoiceInfoForm.invoiceMoney) !== Number(totalDeclaredValue)) {
            this.$message.error(this.$t('collectionCenter.valueMismatchAlert'));
            return;
          }
        }
        const loading = this.$loading({
          fullscreen: true,
          lock: true,
          spinner: 'el-icon-loading',
          text: 'loading...',
          background: 'rgba(250, 250, 250, 0.6)'
        });
        createOrder(data)
          .then((res) => {
            if (res.code === 200) {
              this.countdownDialog = true;
            }
          })
          .finally(() => {
            loading.close();
          });
      }
    },
    // 去除所有的空格
    removeSpaces(str) {
      return str.replace(/\s/g, '');
    },
    toWillyNumber() {
      this.countdownDialog = false;
      this.$router.push({ path: '/expressDataCenter/OrderCenter/logisticsOrders' });
    },
    // 继续下单
    continuePlaceOrders() {
      this.countdownDialog = false;
      this.$router.push({ path: '/expressDataCenter/OrderCenter/placeOrder' });
      this.baseRuleForm.cargoType = 0;
      this.orderPackageListInfo.detailList = [];
      this.orderPackageListInfo.orderWaybillListNew = [];
      this.orderPackageListInfo.orderWaybillList = [
        {
          dictName: 'WRPER1',
          tradeType: 1, // 交易类型
          length: 0, // 长
          width: 0, // 宽
          height: 0, // 高
          weight: 0, // 重量(KG)
          TotalNumberPieces: undefined, //  总件数
          totalParcelDeclaredWeight: undefined, //  包裹总重量（kg）
          totalParcelDeclaredVolume: undefined, //  包裹总体积（m³）
          invoiceNumber: '', // 发票号
          invoiceSerialNumber: '', // 发票序列号
          invoiceIssueDate: '', // 开票日期
          invoiceAccessKey: '', // 发票密钥
          scanOrderNumber: '', // 扫描单号
          invoiceMoney: '', // 开票金额
          waybillType: 'goods',
          exchangeOrder: false,
          hasBack: false,
          packageType: [
            // 包裹类型
            { code: this.$t('placeOrder.package'), value: 'package' },
            { code: this.$t('orderCenterCont.commodity'), value: 'goods' },
            { code: this.$t('orderCenterCont.gift'), value: 'gift' },
            { code: this.$t('orderCenterCont.file'), value: 'file' },
            { code: this.$t('orderCenterCont.other'), value: 'other' }
          ], // 当前选择包裹类型
          orderItemList: [
            {
              id: 0,
              name: '', // 物品名称
              declaredValue: '', // 输入的单价
              declaredWeight: null,
              quantity: '', // 数量
              length: 0, // 长
              width: 0, // 宽
              height: 0 // 高
            }
          ]
        }
      ];
      this.$refs['baseRuleForm']?.resetFields();
      this.$refs['senderInfoForm']?.resetFields();
      this.$refs['receiverInfoForm']?.resetFields();
      this.$refs['packageRuleForm']?.resetFields();
      if (this.baseRuleForm.cargoType === 1) {
        this.$refs['InvoiceInfoRuleForm']?.resetFields();
      }
    },
    // 清空
    empty() {
      this.$refs['baseRuleForm']?.resetFields();
      this.$refs['senderInfoForm']?.resetFields();
      this.$refs['receiverInfoForm']?.resetFields();
      this.$refs['packageRuleForm']?.resetFields();
      if (this.baseRuleForm.cargoType === 1) {
        this.$refs['InvoiceInfoRuleForm']?.resetFields();
      }
      this.resetCode();
    },
    resetCode() {
      this.InvoiceInfoForm = {
        invoiceIssueDate: '',
        invoiceMoney: '',
        invoiceNumber: '',
        invoiceSerialNumber: '',
        invoiceAccessKey: ''
      };
      let orderItemList = [];
      if (this.baseRuleForm.cargoType === 1) {
        orderItemList = [
          {
            sku: '', // 产品SKU代码
            name: '', // 产品名称
            declaredValue: '', // 产品单价
            declaredWeight: null,
            quantity: '' // 数量
          }
        ];
      } else {
        orderItemList = [
          {
            name: '', // 物品名称
            declaredValue: '', // 输入的单价
            quantity: '' // 数量
          }
        ];
      }
      this.orderPackageListInfo.detailList = [];
      this.orderPackageListInfo.orderWaybillListNew = [];
      this.orderPackageListInfo.orderWaybillList = [
        {
          dictName: 'WRPER1',
          tradeType: 1, // 交易类型
          length: 0, // 长
          width: 0, // 宽
          height: 0, // 高
          weight: 0, // 重量(KG)
          TotalNumberPieces: undefined, //  总件数
          totalParcelDeclaredWeight: undefined, //  包裹总重量（kg）
          totalParcelDeclaredVolume: undefined, //  包裹总体积（m³）
          invoiceNumber: '', // 发票号
          invoiceSerialNumber: '', // 发票序列号
          invoiceIssueDate: '', // 开票日期
          invoiceAccessKey: '', // 发票密钥
          scanOrderNumber: '', // 扫描单号
          invoiceMoney: '', // 开票金额
          waybillType: 'goods',
          exchangeOrder: false,
          hasBack: false,
          packageType: [
            // 包裹类型
            { code: this.$t('placeOrder.package'), value: 'package' },
            { code: this.$t('orderCenterCont.commodity'), value: 'goods' },
            { code: this.$t('orderCenterCont.gift'), value: 'gift' },
            { code: this.$t('orderCenterCont.file'), value: 'file' },
            { code: this.$t('orderCenterCont.other'), value: 'other' }
          ], // 当前选择包裹类型
          orderItemList
        }
      ];
    },
    // 复制订单
    getSearch() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          const data = { waybillNumber: this.order.WaybillNumber };
          CopyOrder(data)
            .then((res) => {
              this.tableData = [];
              if (res.code === 200 && res.data.length) {
                // 👇 核心：根据 id 查找对象
                this.customerObj = this.customerList.find(
                  (item) => item.id === res.data[0].customerId
                );
                return sensitiveViewPlaintext({ data: { dataInfo: res.data }}).then((dataObj) => {
                  if (dataObj.code === 200) {
                    this.orderInformation = dataObj.data.dataInfo;
                    this.tableData = dataObj.data.dataInfo;
                  }
                });
              }
            })
            .catch((e) => {
              this.tableData = [];
            });
        }
      });
    },
    // 复制订单点击确认
    async confirmOrderDialog(row) {
      if (row === 0) {
        this.$refs['ruleForm'].validate((valid) => {
          if (valid) {
            const data = { waybillNumber: this.order.WaybillNumber };
            CopyOrder(data)
              .then(async(res) => {
                if (res.code === 200 && res.data.length) {
                  // 👇 核心：根据 id 查找对象
                  this.customerObj = this.customerList.find(
                    (item) => item.id === res.data[0].customerId
                  );
                  return sensitiveViewPlaintext({ data: res.data[0] }).then(async(dataObj) => {
                    if (dataObj.code === 200) {
                      this.orderInformation = dataObj.data;
                      this.orderDialog = false;
                      this.baseRuleForm.collectType = String(this.orderInformation.collectType);
                      if (this.orderInformation.orderPackageType) {
                        if (Number(this.orderInformation.orderPackageType) === 2) {
                          this.baseRuleForm.orderPackageType = 1;
                        } else {
                          this.baseRuleForm.orderPackageType = Number(
                            this.orderInformation.orderPackageType
                          );
                        }
                      }
                      this.baseRuleForm.cargoType = this.orderInformation.cargoType || 0;
                      if (this.baseRuleForm.cargoType === 1) {
                        this.orderInformation.waybillOrderList.forEach((item) => {
                          // 发票信息：
                          this.InvoiceInfoForm = {
                            invoiceIssueDate: item.invoiceIssueDate + ' 00:00:00',
                            invoiceMoney: item.invoiceMoney,
                            invoiceNumber: item.invoiceNumber,
                            invoiceSerialNumber: item.invoiceSerialNumber,
                            invoiceAccessKey: item.invoiceAccessKey
                          };
                        });
                      }
                      this.baseRuleForm.customerId = this.orderInformation.customerId;
                      this.isInput = false;
                      this.baseRuleForm.expressType = Number(this.orderInformation.expressType);
                      this.baseRuleForm.customerNumber = null;
                      this.baseRuleForm.merchantNumber = this.orderInformation.merchantNumber;
                      this.baseRuleForm.merchantName = this.orderInformation.merchantName;
                      this.baseRuleForm.paymentType = this.orderInformation.paymentType;
                      this.receiverInfoParams = this.orderInformation.receiverInfo;
                      this.senderInfoParams = this.orderInformation.senderInfo;
                      this.handleCNPJ(this.senderInfoParams.senderTax, 1);
                      this.handleCNPJ(this.receiverInfoParams.receiveTax, 2);
                      this.orderInformation.waybillOrderList.forEach((item) => {
                        item.tradeType = item.tradeType ? item.tradeType : 1;
                        if (item.invoiceIssueDate) {
                          const dateList = item.invoiceIssueDate.split(' ');
                          if (dateList.length === 1) {
                            item.invoiceIssueDate = dateList[0] + ' 00:00:00';
                          }
                        }
                        if (this.baseRuleForm.cargoType === 1) {
                          item.weight = '';
                          item.volume = '';
                        }
                      });
                      this.orderPackageListInfo.orderWaybillList =
                        this.orderInformation.waybillOrderList;
                      this.orderPackageListInfo.detailList = [];
                      this.orderPackageListInfo.totalParcelDeclaredWeight = this.orderInformation
                        .totalParcelDeclaredWeight
                        ? this.orderInformation.totalParcelDeclaredWeight
                        : 0;
                      this.orderPackageListInfo.totalParcelDeclaredVolume = this.orderInformation
                        .totalParcelDeclaredVolume
                        ? this.orderInformation.totalParcelDeclaredVolume
                        : 0;
                      this.orderPackageListInfo.totalParcel = this.orderInformation
                        .totalCreateOrderCount
                        ? this.orderInformation.totalCreateOrderCount
                        : 0;
                      const packageTypeList = [
                        // 包裹类型
                        { code: this.$t('placeOrder.package'), value: 'package' },
                        { code: this.$t('orderCenterCont.commodity'), value: 'goods' },
                        { code: this.$t('orderCenterCont.gift'), value: 'gift' },
                        { code: this.$t('orderCenterCont.file'), value: 'file' },
                        { code: this.$t('orderCenterCont.other'), value: 'other' }
                      ];
                      this.orderPackageListInfo.orderWaybillList.forEach((item) => {
                        item.packageType = packageTypeList;
                      });
                      if (this.baseRuleForm.cargoType === 1) {
                        const orderWaybillList = res.data.map((arr) => {
                          if (arr.waybillOrderList && arr.waybillOrderList.length > 0) {
                            arr.waybillOrderList.map((item) => {
                              if (item.invoiceIssueDate) {
                                const dateList = item.invoiceIssueDate.split(' ');
                                if (dateList.length === 1) {
                                  item.invoiceIssueDate = dateList[0] + ' 00:00:00';
                                }
                              }
                            });
                          }
                          return arr.waybillOrderList;
                        });
                        this.orderPackageListInfo.orderWaybillList = orderWaybillList.flat();
                        try {
                          const form = {
                            customerId: this.baseRuleForm.customerId
                          };
                          skuInfoOptionSelect(form).then((res) => {
                            if (res.code === 200 && res.data.length > 0) {
                              this.skuAndNameOptions = res.data;
                              this.calculatePackageWeightAndVolume();
                            }
                          });
                        } catch (error) {
                          console.error('获取 SKU 信息失败:', error);
                        }
                      }
                      this.getSenderCity();
                      this.getReceiveCity();
                    }
                  });
                }
              })
              .catch(() => {
                this.orderDialog = false;
              });
          }
        });
      } else {
        this.orderInformation = row;
        this.orderDialog = false;
        this.baseRuleForm.collectType = String(this.orderInformation.collectType);
        if (this.orderInformation.orderPackageType) {
          if (Number(this.orderInformation.orderPackageType) === 2) {
            this.baseRuleForm.orderPackageType = 1;
          } else {
            this.baseRuleForm.orderPackageType = Number(this.orderInformation.orderPackageType);
          }
        }
        this.baseRuleForm.cargoType = this.orderInformation.cargoType || 0;
        if (this.baseRuleForm.cargoType === 1) {
          this.orderInformation.waybillOrderList.forEach((item) => {
            // 发票信息：
            this.InvoiceInfoForm = {
              invoiceIssueDate: item.invoiceIssueDate + ' 00:00:00',
              invoiceMoney: item.invoiceMoney,
              invoiceNumber: item.invoiceNumber,
              invoiceSerialNumber: item.invoiceSerialNumber,
              invoiceAccessKey: item.invoiceAccessKey
            };
          });
        }
        this.baseRuleForm.customerId = this.orderInformation.customerId;
        this.isInput = false;
        this.baseRuleForm.expressType = Number(this.orderInformation.expressType);
        this.baseRuleForm.customerNumber = null;
        this.baseRuleForm.merchantNumber = this.orderInformation.merchantNumber;
        this.baseRuleForm.merchantName = this.orderInformation.merchantName;
        this.baseRuleForm.paymentType = this.orderInformation.paymentType;
        this.receiverInfoParams = this.orderInformation.receiverInfo;
        this.senderInfoParams = this.orderInformation.senderInfo;
        this.handleCNPJ(this.senderInfoParams.senderTax, 1);
        this.handleCNPJ(this.receiverInfoParams.receiveTax, 2);
        this.orderInformation.waybillOrderList.forEach((item) => {
          item.tradeType = item.tradeType ? item.tradeType : 1;
          if (item.invoiceIssueDate) {
            const dateList = item.invoiceIssueDate.split(' ');
            if (dateList.length === 1) {
              item.invoiceIssueDate = dateList[0] + ' 00:00:00';
            }
          }
          if (this.baseRuleForm.cargoType === 1) {
            item.weight = '';
            item.volume = '';
          }
        });
        this.orderPackageListInfo.orderWaybillList = this.orderInformation.waybillOrderList;
        this.orderPackageListInfo.detailList = [];
        this.orderPackageListInfo.totalParcelDeclaredWeight = this.orderInformation
          .totalParcelDeclaredWeight
          ? this.orderInformation.totalParcelDeclaredWeight
          : 0;
        this.orderPackageListInfo.totalParcelDeclaredVolume = this.orderInformation
          .totalParcelDeclaredVolume
          ? this.orderInformation.totalParcelDeclaredVolume
          : 0;
        this.orderPackageListInfo.totalParcel = this.orderInformation.totalCreateOrderCount
          ? this.orderInformation.totalCreateOrderCount
          : 0;
        const packageTypeList = [
          // 包裹类型
          { code: this.$t('placeOrder.package'), value: 'package' },
          { code: this.$t('orderCenterCont.commodity'), value: 'goods' },
          { code: this.$t('orderCenterCont.gift'), value: 'gift' },
          { code: this.$t('orderCenterCont.file'), value: 'file' },
          { code: this.$t('orderCenterCont.other'), value: 'other' }
        ];
        this.orderPackageListInfo.orderWaybillList.forEach((item) => {
          item.packageType = packageTypeList;
        });
        if (this.baseRuleForm.cargoType === 1) {
          console.log(row, 'this.baseRuleForm.cargoType');
          const orderWaybillList =
            [row].map((arr) => {
              if (arr.waybillOrderList && arr.waybillOrderList.length > 0) {
                arr.waybillOrderList.forEach((item) => {
                  if (item.invoiceIssueDate) {
                    const dateList = item.invoiceIssueDate.split(' ');
                    if (dateList.length === 1) {
                      item.invoiceIssueDate = dateList[0] + ' 00:00:00';
                    }
                  }
                });
              }
              return arr.waybillOrderList;
            })[0] || [];
          this.orderPackageListInfo.orderWaybillList = orderWaybillList.flat();
          try {
            const form = {
              customerId: this.baseRuleForm.customerId
            };
            skuInfoOptionSelect(form).then((res) => {
              if (res.code === 200 && res.data.length > 0) {
                this.skuAndNameOptions = res.data;
                this.calculatePackageWeightAndVolume();
              }
            });
          } catch (error) {
            console.error('获取 SKU 信息失败:', error);
          }
        }
        this.getSenderCity();
        this.getReceiveCity();
      }
      console.log(this.orderPackageListInfo, '===this.orderPackageListInfo');
    },
    // 客户发件地址
    getSearchAddress() {
      const data = {
        params: {}
      };
      data.pageSize = this.queryForm.pageSize;
      data.pageNumber = this.queryForm.pageNumber;
      data.params.customerId = this.baseRuleForm.customerId;
      if (this.addressForm.type === this.$t('placeOrder.receiveName')) {
        data.params.name = this.addressForm.name;
        data.params.zipcode = '';
      } else if (this.addressForm.type === this.$t('placeOrder.senderName')) {
        data.params.name = this.addressForm.name;
        data.params.zipcode = '';
      } else {
        if (this.addressTitle === this.$t('placeOrder.receiveName')) {
          data.params.zipcode = this.addressForm.name;
          data.params.name = '';
        } else {
          data.params.zipcode = this.addressForm.name;
          data.params.name = '';
        }
      }
      pageCustomerAddress(data).then((res) => {
        if (res.code === 200) {
          this.queryForm.total = res.data.total;
          this.customerAddressList = res.data.records;
        }
      });
      // if (this.addressTitle === this.$t('placeOrder.receiveName')) {
      //   pageCustomerReceive(data).then(res => {
      //     if (res.code===200) {
      //       this.customerAddressList = res.data.records;
      //       this.queryForm.total = res.data.total;
      //     }
      //   });
      // } else {
      //   pageCustomerSender(data).then(res => {
      //     if (res.code===200) {
      //       this.customerAddressList = res.data.records;
      //       this.queryForm.total = res.data.total;
      //     }
      //   });
      // }
    },
    customerAddress(title) {
      if (this.baseRuleForm.customerId) {
        this.$nextTick(() => {
          this.addressForm.type = title;
        });
        this.addressTitle = title;
        this.addressDialog = true;
      } else {
        this.$message.error(this.$t('placeOrder.selectClient'));
      }
    },
    // 选择客户地址
    selectAddress(item, title) {
      if (title === this.$t('placeOrder.senderName')) {
        delete item.id;
        this.senderInfoParams.senderName = item.name;
        this.senderInfoParams.senderMobile = item.phone;
        this.senderInfoParams.senderTax = item.cpf;
        this.senderInfoParams.senderMail = item.email;
        this.senderInfoParams.senderHouseNumber = item.houseNumber;
        this.senderInfoParams.senderIeNumber = item.ieNumber;
        this.senderInfoParams.senderComplement = item.complement;
        this.senderInfoParams.senderZipcode = item.zipcode;
        this.senderInfoParams.senderCity = item.city;
        this.senderInfoParams.senderArea = item.area;
        this.senderInfoParams.senderStreet = item.street;
        this.senderInfoParams.senderAddress = item.addressDetail;
        this.senderInfoParams.senderState = item.state;
        this.senderInfoParams.senderPhone = item.telephone;
      } else {
        delete item.id;
        this.receiverInfoParams.receiveName = item.name;
        this.receiverInfoParams.receiveMobile = item.phone;
        this.receiverInfoParams.receiveTax = item.cpf;
        this.receiverInfoParams.receiveMail = item.email;
        this.receiverInfoParams.receiveHouseNumber = item.houseNumber;
        this.receiverInfoParams.receiveIeNumber = item.ieNumber;
        this.receiverInfoParams.receiveComplement = item.complement;
        this.receiverInfoParams.receiveZipcode = item.zipcode;
        this.receiverInfoParams.receiveCity = item.city;
        this.receiverInfoParams.receiveArea = item.area;
        this.receiverInfoParams.receiveStreet = item.street;
        this.receiverInfoParams.receiveAddress = item.addressDetail;
        this.receiverInfoParams.receivePhone = item.telephone;
      }
      this.addressDialog = false;
    },
    // 同步客户
    SynchronousCustomer(flag) {
      if (this.baseRuleForm.customerId) {
        if (flag === this.$t('placeOrder.senderName')) {
          this.$refs['senderInfoForm'].validate((valid) => {
            if (valid) {
              const data = {
                name: this.senderInfoParams.senderName,
                phone: this.senderInfoParams.senderMobile,
                cpf: this.senderInfoParams.senderTax,
                email: this.senderInfoParams.senderMail,
                houseNumber: this.senderInfoParams.senderHouseNumber,
                ieNumber: this.senderInfoParams.senderIeNumber,
                complement: this.senderInfoParams.senderComplement,
                zipcode: this.senderInfoParams.senderZipcode,
                city: this.senderInfoParams.senderCity,
                area: this.senderInfoParams.senderArea,
                street: this.senderInfoParams.senderStreet,
                addressDetail: this.senderInfoParams.senderAddress,
                state: this.senderInfoParams.senderState,
                telephone: this.senderInfoParams.senderPhone
              };
              data.customerId = this.baseRuleForm.customerId;
              data.customerName = this.customerObj.username;
              addCustomerAddress(data)
                .then((res) => {
                  if (res.code === 200) {
                    this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
                  }
                })
                .catch(() => {});
            } else {
              this.$message.error(this.$t('GlobalSetObj.required'));
            }
          });
        } else {
          this.$refs['receiverInfoForm'].validate((valid) => {
            if (valid) {
              const data = {
                name: this.receiverInfoParams.receiveName,
                phone: this.receiverInfoParams.receiveMobile,
                cpf: this.receiverInfoParams.receiveTax,
                email: this.receiverInfoParams.receiveMail,
                houseNumber: this.receiverInfoParams.receiveHouseNumber,
                ieNumber: this.receiverInfoParams.receiveIeNumber,
                complement: this.receiverInfoParams.receiveComplement,
                zipcode: this.receiverInfoParams.receiveZipcode,
                city: this.receiverInfoParams.receiveCity,
                area: this.receiverInfoParams.receiveArea,
                street: this.receiverInfoParams.receiveStreet,
                addressDetail: this.receiverInfoParams.receiveAddress,
                state: this.receiverInfoParams.receiveState,
                telephone: this.receiverInfoParams.receivePhone
              };
              data.customerId = this.baseRuleForm.customerId;
              addCustomerAddress(data)
                .then((res) => {
                  if (res.code === 200) {
                    this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
                  }
                })
                .catch(() => {});
            } else {
              this.$message.error(this.$t('GlobalSetObj.required'));
            }
          });
        }
      } else {
        this.$message.error(this.$t('placeOrder.selectClient'));
      }
    },
    // 点击分页
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.getSearchAddress();
    },
    handleCurrentChange(val) {
      this.queryForm.pageNumber = val;
      this.getSearchAddress();
    },
    // 选择客户
    selectCustomerId(val) {
      console.log(val, 'val', this.customerList);
      // 👇 核心：根据 id 查找对象
      const customerObj = this.customerList.find((item) => item.id === val);
      console.log('找到的客户对象：', customerObj);
      this.customerObj = customerObj;
      this.isInput = val === '';
      this.commercialList = [];
      this.baseRuleForm.merchantNumber = '';
      if (this.baseRuleForm.cargoType === 1 && val) {
        this.customeGetSkuAndName();
      }
    },
    // 节流
    throttle(query, func, wait) {
      const _this = this;
      const now = new Date().getTime();
      if (now - _this.timer > wait) {
        _this.timer = now + wait;
        const tiem = setTimeout(function() {
          clearTimeout(tiem);
          func(query);
        }, wait);
      }
    },
    getShanghu() {
      if (this.baseRuleForm.customerId) {
        const data = {
          customerId: this.baseRuleForm.customerId
        };
        customerMerchant(data).then((res) => {
          if (res.code === 200) {
            this.commercialList = res.data;
          }
        });
      }
    },
    focuseventEnter() {
      this.getShanghu();
    },
    // 触发回车事件使用节流
    eventEnter(query) {
      if (query) {
        this.throttle(query, this.remoteMethod, 300);
      } else {
        this.getShanghu();
      }
    },
    // 远程搜索
    remoteMethod(query) {
      if (query) {
        if (this.baseRuleForm.customerId) {
          const data = {
            customerId: this.baseRuleForm.customerId,
            merchantBlur: query
          };
          inquireMerchant(data).then((res) => {
            if (res.code === 200) {
              this.commercialList = res.data;
            }
          });
        }
      }
    },
    // 切换商户
    handlemerchantCode(val) {
      console.log(this.baseRuleForm.customerId, 'this.baseRuleForm.customerId');
      console.log(val, '商户三生三世');
      if (val) {
        const findObjCus = this.commercialList.find((item) => {
          return item.merchantNumber === val;
        });
        if (findObjCus) {
          this.baseRuleForm.merchantName = findObjCus.merchantName;
          this.baseRuleForm.merchantNumber = findObjCus.merchantNumber;
        } else {
          this.baseRuleForm.merchantName = '';
          this.baseRuleForm.merchantNumber = '';
        }
        console.log(findObjCus, 'findObjCus');
      } else {
        this.getShanghu();
      }
    }
  }
};
</script>

<style>
/* 产品名称下拉框数据超长优化 */
.el-select-dropdown.el-popper {
  width: 400px;
}
</style>
<style lang="scss" scoped>
.addPackageClass {
  cursor: pointer;
  color: #409eff;
  font-weight: bold;
  text-align: center;
  margin-bottom: 5px;
}

.goodsBoxClass {
  display: flex;
  align-items: center;
}

.inputClass {
  position: relative;
}

.inputClass ::v-deep .el-input__count-inner {
  background: transparent;
}

.inputClass ::v-deep .el-input__count {
  background: transparent;
  align-items: flex-end;
  position: absolute;
  right: 0;
  bottom: 0;
  height: auto;
}

.forecastClass {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 30px 40px;
  box-sizing: border-box;
  position: sticky; // 吸底
  bottom: 0; // 吸底距离
  width: 100%;
  background: #fff;

  .forecast_div {
    color: #000;
    font-size: 20px;

    .forecast_span {
      font-size: 30px;
      margin-left: 10px;
    }
  }
}

::v-deep .demo-ruleForm .el-input-group__append {
  background-color: #409eff;
  border: 1px solid #409eff;
  color: #fff;
}

.countdown {
  width: 60px;
  height: 60px;
  font-size: 50px;
  border-radius: 30px;
  background-color: #ddf0f8;
}

::v-deep .el-dialog__title {
  font-size: 20px;
  font-weight: bold;
}

::v-deep .addressList .el-input__inner {
  border: none;
  font-weight: bold;
}

.addressClass {
  height: 360px;
  margin-top: 20px;
  overflow: auto;

  .nodataImage {
    height: 250px;
    display: flex;
    align-items: center;
    justify-content: center;

    .svg-icon {
      width: 120px !important;
      height: 120px !important;
    }
  }

  .addressItem {
    font-size: 14px;
    background-color: #f2f2f2;
    margin-bottom: 15px;
    cursor: pointer;
    padding: 15px 10px;
    line-height: 25px;

    &:hover {
      background-color: #ddf0f8;
    }
  }
}

.expressOrder {
  padding: 20px;
  padding-bottom: 0;
  box-sizing: border-box;

  .orderInfoList {
    width: 150px;
    height: 150px;
    line-height: 30px;
    text-align: center;
    position: fixed;
    top: 120px;
    right: 7px;
    left: 90%;
  }
}

.orderInfo {
  width: 90%;
}

.basicInformation {
  margin-bottom: 20px;

  .title {
    margin-bottom: 15px;
  }

  .center {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .start {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  ::v-deep input::-webkit-outer-spin-button,
  ::v-deep input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
  }

  ::v-deep input[type='number'] {
    -moz-appearance: textfield !important;
  }

  .customerContent {
    width: 100%;
    padding: 10px;
    background: #f1f3f4;

    .formTable {
      width: 120%;
    }

    .moreInfo {
      color: #409eff;
      font-size: 14px;
      cursor: pointer;
    }
  }

  .verticallyCentered {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .delPackge {
    margin-top: 28px;
  }

  .input-with-select ::v-deep .el-input__inner {
    padding-left: 40px !important;
  }

  .input-with-select ::v-deep .el-input__prefix {
    color: #606266;
    height: 30px;
    width: 30px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    justify-content: center;
    align-items: center;
    border-right: 1px solid #dddede;
  }

  .upload-demo .upLoadHint {
    color: #f66c6c;
    font-size: 12px;
    text-align: left;
    float: left;
    padding: 0;
    line-height: 16px !important;
  }

  .isInvoiceName {
    display: flex;
    flex-flow: nowrap;

    i {
      color: red;
      cursor: pointer;
      font-size: 20px;
      margin-top: 10px;
    }

    span {
      font-size: 14px;
      font-weight: bold;
      padding-left: 20px;
      margin-right: 30px;
      word-break: break-all; /*word-break: normal|break-all|keep-all;在恰当的断字点进行换行,break-all 允许在单词内换行,keep-all 只能在半角空格或连字符处换行,normal 使用浏览器默认的换行规则。*/
      text-overflow: ellipsis; /*溢出文字显示省略号*/
      display: -webkit-box; /** 对象作为伸缩盒子模型显示 **/
      -webkit-box-orient: vertical; /** 设置或检索伸缩盒对象的子元素的排列方式 **/
      -webkit-line-clamp: 1; /** 显示的行数 **/
      overflow: hidden; /** 隐藏超出的内容 **/
    }
  }
}

.sucessIcon {
  width: 30px;
  height: 30px;
  background-color: #00a121;
  color: #ffffff;
  text-align: center;
  line-height: 30px;
  border-radius: 50%;
  margin-right: 10px;
}
</style>
<style>
.volumeClass {
  position: absolute;
  display: flex;
  align-items: center;
  height: 40px;
  line-height: 16px;
  bottom: 25px;
  color: #409eff;
  cursor: pointer;
}

.weightVolume .el-dialog__body {
  padding: 0 !important;
}

.copyOrder .el-dialog__header {
  height: 50px;
}
</style>
